{
  "topMenu": {
    "dihTitle": "Centre d'intelligence des données",
    "dihSubTitle": "Extraire de la valeur des données en toute sécurité",
    "logout": "Déconnexion",
    "dihPortal": "Portail DIH",
    "cofinityDataspace": "Portail Dataspace",
    "portal": "Portail"
  },
  "userLogoutAlert": {
    "title": "Êtes-vous sûr de vouloir vous déconnecter ?",
    "back": "Retour",
    "logout": "Déconnexion"
  },
  "languages": {
    "en": "English",
    "de": "German (Deutsch)",
    "es": "Spanish (Español)",
    "fr": "French (Français)",
    "zh": "Chinese (中文/简体)",
    "ja": "Japanese (日本語)"
  },
  "sideMenu": {
    "home": "Accueil",
    "collapse": "Réduire la barre latérale",
    "help": "Aide",
    "prepare": "Gestion des modèles",
    "model": "Modèle de données",
    "mapping": "Mappage de données",
    "converter": "Convertisseur de données",
    "provide": "Fournir",
    "publishData": "Publier des données",
    "assets": "Actifs",
    "policyPublicationTemplate": "Modèle de publication de politique",
    "uploadHistory": "Historique des téléchargements d'actifs",
    "consume": "Consommer",
    "searchDataOffers": "Rechercher des offres de données",
    "simulateDataOffers": "Simuler des offres de données",
    "negotiatedDataOffers": "Offres de données négociées",
    "downloadHistory": "Historique des téléchargements d'actifs",
    "govern": "Gouverner",
    "myPolicies": "Mes politiques",
    "createPolicies": "Créer des politiques",
    "policyTemplate": "Modèles de politiques",
    "manageAndConfig": "Configurer",
    "connections": "Gérer les connecteurs",
    "jobs": "Journaux de processus",
    "monitoring": "Surveiller",
    "licences": "Licences",
    "contractAgreements": "Accords de contrat",
    "providedAgreements": "Accords de contrat fournis",
    "incomingAgreements": "Offres de données entrantes",
    "consumedAgreements": "Accords de contrat consommés",
    "consumeAutomation": "Automatisation des politiques de consommation",
    "networkAnalytics": "Analyses réseau",
    "otherLogs": "Autres journaux",
    "digitalTwin": "Explorateur de jumeaux numériques",
    "messagesBrowserInbound": "Messages entrants",
    "messagesBrowserOutbound": "Messages sortants",
    "applications": "Applications",
    "electronicControlUnit": "Unité de Contrôle Électronique",
    "pcfExchange": "Échange PCF (Jupiter)",
    "pcfExchangeV9": "Échange PCF (Saturn)",
    "pcfRequests": "Demandes de données PCF",
    "pcfExchangeHistory": "Historique d'échange de données PCF",
    "pcfExchangeV9History": "Historique d'échange de données PCF v9",
    "publicationTemplates": "Modèles de publication",
    "certificateManagement": "Gestion des certificats",
    "certificates": "Certificats",
    "connectors": "Mes connecteurs",
    "contractDefinitions": "Mes définitions de contrat"
  },
  "workspace": {
    "rail": {
      "label": "Navigation principale",
      "home": "Accueil",
      "apps": "Applications",
      "advanced": "Avancé",
      "help": "Aide"
    },
    "apps": {
      "title": "Actuellement dans",
      "none": "Aucun espace de travail sélectionné",
      "search": "Rechercher",
      "close": "Fermer",
      "comingSoon": "Bientôt disponible",
      "noResults": "Aucune application correspondante.",
      "names": {
        "certificateManagement": "Gestion des certificats",
        "pcfJupiter": "Empreinte carbone des produits Jupiter",
        "pcfSaturn": "Empreinte carbone des produits Saturn",
        "blockNotifications": "Notifications de blocage",
        "traceability": "Traçabilité",
        "cyberSecurityMetrics": "Métriques de cybersécurité",
        "electronicControlUnit": "Calculateur électronique",
        "batteryPassport": "Passeport de batterie",
        "simpleFileExchange": "Échange de fichiers simple",
        "advanced": "Avancé"
      }
    },
    "menu": {
      "groups": {
        "pcfRequestsResponses": "Demandes et réponses PCF",
        "overview": "Aperçu",
        "provide": "Fournir",
        "consume": "Consommer",
        "history": "Historique",
        "notifications": "Notifications",
        "diagnostics": "Diagnostics",
        "pcfRequests": "Demandes PCF",
        "pcfCalculation": "Calcul PCF",
        "ecuMessages": "Messages ECU",
        "governance": "Gouvernance",
        "data": "Données",
        "connections": "Connexions",
        "operationsDiagnostics": "Opérations et diagnostics",
        "digitalTwins": "Jumeaux numériques"
      },
      "items": {
        "pcfProvider": "Fournisseur PCF",
        "pcfConsume": "Consommation PCF",
        "dashboard": "Tableau de bord",
        "userGuide": "Guide d'utilisation et tutoriels",
        "developerDocumentation": "Documentation développeur",
        "publishCertificate": "Publier un certificat",
        "myCertificates": "Mes certificats",
        "sharedCertificates": "Certificats partagés",
        "mySites": "Mes sites",
        "discoverCertificates": "Découvrir les certificats",
        "downloadCertificates": "Télécharger les certificats",
        "consumptionHistory": "Historique de consommation",
        "messagesLog": "Journal des messages",
        "createPcfOffer": "Créer une offre PCF",
        "discoverPcf": "Découvrir et demander des données PCF",
        "pcfAspects": "Aspects PCF",
        "pcfDataRequests": "Demandes de données PCF",
        "pcfExchangeHistory": "Historique des échanges PCF",
        "pcfCalculator": "Calculateur PCF",
        "sendBlockNotifications": "Envoyer des notifications de blocage",
        "receivedBlockNotifications": "Notifications de blocage reçues",
        "sentNotificationsHistory": "Historique des notifications envoyées",
        "receivedNotificationsHistory": "Historique des notifications reçues",
        "createTraceabilityOffer": "Créer une offre de traçabilité",
        "createQualityAlert": "Créer une alerte qualité ou une enquête",
        "discoverTraceability": "Découvrir les données de traçabilité",
        "industryCoreNotifications": "Notifications Industry Core",
        "traceabilityNotifications": "Notifications de traçabilité",
        "exchangeHistory": "Historique des échanges",
        "contractAgreements": "Accords contractuels",
        "createSendMetrics": "Créer et envoyer des métriques",
        "receiveViewMetrics": "Recevoir et afficher des métriques",
        "ecuAssets": "Actifs ECU",
        "outgoingMessages": "Messages sortants",
        "incomingMessages": "Messages entrants",
        "processLogs": "Journaux de processus",
        "apiPollingLogs": "Journaux d'interrogation API",
        "myPolicies": "Mes politiques",
        "myContractAgreements": "Mes accords contractuels",
        "myContractDefinitions": "Mes définitions de contrat",
        "myAssets": "Mes actifs",
        "simulateDataOffers": "Simuler des offres de données",
        "myConnectors": "Mes connecteurs",
        "externalConnectionManagement": "Gestion des connexions externes",
        "twinBrowserProvider": "Navigateur de jumeaux - fournisseur",
        "twinBrowserConsumer": "Navigateur de jumeaux - consommateur",
        "switchApplication": "Changer d'application"
      }
    }
  },
  "versionModal": {
    "title": "Informations générales",
    "error": "Impossible de récupérer les détails de la version",
    "table": {
      "title": "Détails du composant",
      "componentName": "Nom du composant",
      "imageVersion": "Version de l'image",
      "chartVersion": "Version du graphique"
    }
  },
  "dropdown": {
    "selectAll": "Tout sélectionner",
    "noOption": "Aucune option disponible",
    "noSuchOption": "Il n'y a pas d'option comme ça ...",
    "selectConnection": "Sélectionner une connexion"
  },
  "certificateManagement": {
    "title": "Gestion des certificats de partenaires commerciaux",
    "description": "Bienvenue dans la solution d'échange de gestion de certificats de partenaires commerciaux facile à utiliser dans Catena-X.",
    "howTo": {
      "description": "Découvrez le catalogue d'offres de données d'autres entreprises membres de Catena-X. Vous pouvez rechercher, sélectionner et vous abonner à une offre de certificat. Vous pouvez rechercher des offres de certificats en utilisant le nom de l'entreprise.",
      "doc": "Vous voulez en savoir plus sur le fonctionnement de la gestion des certificats de partenaires commerciaux ? "
    },
    "landingTiles": {
      "tile_1": {
        "title": "Publier un certificat",
        "description": "Créez et partagez vos certificats de site dans le réseau Catena-X."
      },
      "tile_2": {
        "title": "Découvrir et consommer des certificats",
        "description": "Recherchez et téléchargez facilement des certificats de site et d'entreprise."
      },
      "tile_3": {
        "title": "Historique de publication des certificats",
        "description": "Vue d'ensemble de tous vos certificats fournis"
      },
      "tile_4": {
        "title": "Historique des certificats consommés",
        "description": "Vue d'ensemble de tous vos certificats consommés"
      },
      "tile_5": {
        "title": "Demandes entrantes de certificats",
        "description": "Vue d'ensemble des demandes entrantes pour partager des certificats"
      },
      "tile_6": {
        "title": "Statut des certificats sortants",
        "description": "Vue d'ensemble des actions de partage de certificats"
      },
      "tile_7": {
        "title": "Demander des certificats",
        "description": "Recherchez et téléchargez facilement des certificats de site et d'entreprise."
      }
    },
    "recentCertificateRequests": "Demandes récentes de données de certificats entrantes",
    "learnMore": "En savoir plus sur la gestion des certificats",
    "requestCertificates": "Demander de nouveaux certificats",
    "pushCertificate": "Envoyer un certificat",
    "pushDescription": "Le certificat existant sera partagé avec le partenaire sélectionné ci-dessous. Veuillez noter que le même ensemble de politiques s’appliquera, comme dans l’offre d’origine. Si vous souhaitez modifier les politiques, veuillez créer une nouvelle offre de données.",
    "pushSuccess": "Le processus de promotion des certificats a commencé ! L’identifiant du poste est {id}",
    "receiverBpn": "Récepteur BPN",
    "providerBpn": "BPN du fournisseur",
    "locationBpns": "Localisation BPNs",
    "certificateType": "Type de certificat",
    "requestSuccess": "Demande de certificat soumise avec succès!",
    "pushResult": "{successful} sur {total} demandes {status} ont réussi",
    "receiveConfirmTitle": "Accuser réception du certificat",
    "receiveConfirmDesc": "En cliquant sur Oui, vous confirmez avoir reçu le certificat partagé par le partenaire. Le fournisseur recevra votre accusé de réception. Ensuite, vous pouvez accepter ou rejeter le certificat.",
    "acceptedConfirmTitle": "Accepter le certificat",
    "acceptedConfirmDesc": "En cliquant sur Oui, vous acceptez que le certificat corresponde à vos attentes. Vous pouvez télécharger le certificat au format PDF en cliquant sur l’icône d’affichage.",
    "rejectedConfirmTitle": "Rejeter le certificat",
    "rejectedConfirmDesc": "En cliquant sur Oui, vous rejetez le certificat entrant. Le fournisseur sera informé du rejet. Il pourra le partager à nouveau ou vous pourrez en demander un nouveau.",
    "processStarted": "'{type}' Le processus a commencé ! L’identifiant du poste est {id}",
    "certificateDetails": "Détails du certificat",
    "availableCertificate": "Emplacement du certificat disponible",
    "updateSuccess": "Certificat mis à jour avec succès!",
    "updateFailure": "La mise à jour du certificat a échoué!",
    "wizard": {
      "selectCompanies": "Sélectionnez les entreprises",
      "selectPolicies": "Sélectionnez les politiques"
    },
    "step1Description": "Sélectionnez une ou plusieurs entreprises avec lesquelles partager le certificat. ",
    "step2Description": "Sélectionnez les politiques pour le partage de certificat. ",
    "noPoliciesFound": "Aucune politique trouvée pour les entreprises sélectionnées.",
    "policiesFound": "{count} règles trouvées",
    "selectedPolicies": "{count} sélectionnés",
    "policyName": "Nom de la stratégie",
    "bpn": "BPN",
    "policyType": "Taper",
    "errorFetchingPolicies": "Échec de la récupération des stratégies. ",
    "assetId": "ID d'actif",
    "noPoliciesFoundInCatalog": "Aucune politique trouvée dans le catalogue pour les entreprises sélectionnées.",
    "duplicateBpnError": "Vous ne pouvez pas sélectionner le même BPN deux fois.",
    "membershipValue": "Adhésion",
    "contractReference": "Référence du contrat",
    "connectorEndpoint": "Point de terminaison du connecteur",
    "noCompatibleOfferPush": "Aucune offre compatible CCM-Push trouvée. Demandez à vos partenaires commerciaux sélectionnés d'en publier une.",
    "noCompatibleOfferAvailable": "Aucune offre compatible CCM-Available trouvée. Demandez à vos partenaires commerciaux sélectionnés d'en publier une.",
    "certificateDownload": {
      "downloadReceivedJson": "Télécharger le JSON reçu",
      "downloadCertificatePdf": "Télécharger le certificat au format PDF"
    }
  },
  "schemas": {
    "businessPartnerCertificate": {
      "groups": {
        "basicInfo": "Informations de base du certificat",
        "issuer": "Informations de l'émetteur",
        "validity": "Période de validité",
        "trust": "Informations de confiance",
        "validator": "Informations du validateur",
        "application": "Domaine d'application",
        "enclosedSites": "Sites inclus"
      },
      "fields": {
        "businessPartnerNumber": "Numéro de partenaire commercial",
        "registrationNumber": "Numéro d'enregistrement",
        "certificateType": "Type de certificat",
        "certificateVersion": "Version du certificat",
        "issuerName": "Nom de l'émetteur",
        "issuerBpn": "BPN de l'émetteur",
        "validFrom": "Valide à partir de",
        "validUntil": "Valide jusqu'à",
        "trustLevel": "Niveau de confiance",
        "uploaderBpn": "BPN du téléchargeur",
        "validatorBpn": "BPN du validateur",
        "validatorName": "Nom du validateur",
        "areaOfApplication": "Domaine d'application",
        "siteBpn": "BPN du site",
        "siteAreaOfApplication": "Domaine d'application du site"
      },
      "tooltips": {
        "basicInfo": "Un certificat de partenaire commercial décrit un certificat (par exemple ISO9001, IATF-16949) via un document de certificat d'un partenaire commercial Catena-X",
        "businessPartnerNumber": "Le numéro de partenaire commercial (BPN) de l'entité juridique certifiée (sur laquelle le certificat est émis).",
        "registrationNumber": "Numéro d'enregistrement du certificat tel que défini sur le certificat",
        "certificateType": "Type de certificat tel que défini sur le document, les types valides sont enregistrés au contrôleur de métadonnées BPN",
        "certificateVersion": "Version du certificat telle que définie sur le document, généralement la version spécifique d'une norme de certification",
        "issuerName": "Nom de l'émetteur, c'est-à-dire de l'autorité de certification.",
        "issuerBpn": "Le numéro de partenaire commercial (BPN) de l'émetteur.",
        "validFrom": "Date de validité à partir de, telle que définie sur le certificat.",
        "validUntil": "Valide jusqu'à la date définie sur le certificat. Si le certificat n'expire jamais, la valeur attendue est 9999-12-31",
        "trustLevel": "Le niveau de confiance du certificat donné - none, low, high, trusted",
        "uploaderBpn": "Le numéro de partenaire commercial (BPN) du partenaire commercial qui a fourni à l'origine les données ou le document du certificat.",
        "validatorBpn": "Le numéro de partenaire commercial (BPN) du fournisseur de services de données qui a validé le certificat donné",
        "validatorName": "Le nom optionnel du fournisseur de services de données qui a validé le certificat donné",
        "areaOfApplication": "Détails sur les domaines / types d'applications pour lesquels un certificat est valide pour une entreprise et/ou un site.",
        "siteBpn": "Le numéro de partenaire commercial (BPNS ou BPNA) d'un site inclus",
        "siteAreaOfApplication": "Détails sur les domaines / types d'applications pour lesquels un certificat est valide pour une entreprise et/ou un site."
      }
    }
  },
  "common": {
    "start": "Démarrer",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Adresse e-mail",
    "phoneNumber": "Numéro de téléphone",
    "contactPerson": "Personne à contacter",
    "welcome": "Bienvenue",
    "street": "Rue",
    "city": "Ville",
    "country": "Pays",
    "postCode": "Code postal",
    "number": "Numéro",
    "next": "Suivant",
    "prev": "Retour",
    "alreadyAccount": "Vous avez déjà un compte ?",
    "login": "Se connecter",
    "loginNow": "Se connecter maintenant",
    "register": "S'inscrire",
    "home": "Accueil",
    "submit": "Soumettre",
    "attention": "Attention",
    "desc": "Description",
    "website": "Site web",
    "contact": "Contact",
    "details": "Détails",
    "plan": "Plan",
    "table": "Tableau",
    "grid": "Grille",
    "listView": "Vue en liste",
    "gridView": "Vue en grille",
    "firstPage": "À la première page",
    "previousPage": "À la page précédente",
    "nextPage": "À la page suivante",
    "lastPage": "À la dernière page",
    "paginationUnknownButton": "Type de bouton de pagination inconnu",
    "download": "Télécharger",
    "delete": "Supprimer",
    "edit": "Modifier",
    "information": "Information",
    "organization": "Organisation",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "upload": "Télécharger",
    "link": "Lien",
    "view": "Voir",
    "search": "Rechercher",
    "selectOption": "Sélectionner une option",
    "sortBy": "Trier par",
    "dataspace": "Espace de données",
    "select": "Sélectionner",
    "date": "Date",
    "title": "Titre",
    "back": "Retour",
    "startTyping": "Commencer à taper",
    "useCases": "Cas d'utilisation",
    "done": "Terminé",
    "enterValue": "Saisir une valeur",
    "selectValue": "Sélectionner une valeur",
    "selectDate": "Sélectionner une date",
    "selectYear": "Année sélective",
    "refresh": "Actualiser",
    "provided": "Fournis",
    "consumed": "Consommés",
    "searchByName": "Rechercher par nom",
    "close": "Fermer",
    "copyToClipboard": "Copié dans le presse-papiers !",
    "enterKeyName": "Saisir le nom de la clé",
    "fileDownloadSuccess": "Fichier téléchargé avec succès",
    "fileDownloadError": "Échec du téléchargement du fichier",
    "certificate": "Certificat",
    "manageConnections": "Gérer les connexions",
    "confirm": "Confirmer",
    "yes": "Oui",
    "no": "Non",
    "connectionDetails": "{type} Détails de la connexion",
    "hide": "Cacher",
    "unpublish": "Inébranlable",
    "clear": "Clair",
    "viewAll": "Voir tout",
    "apply": "Appliquer",
    "from": "Depuis",
    "to": "À",
    "isRequired": "est requis",
    "confirmationRequired": "Merci de confirmer en cochant la case",
    "send": "Envoyer",
    "update": "Mise à jour",
    "createSend": "Créer et envoyer",
    "share": "Partager",
    "recentRequests": "Demandes récentes",
    "severity": "Gravité",
    "expectedResponseBy": "Réponse attendue de",
    "active": "Actif",
    "viewDocs": "Voir la documentation",
    "request": "Demande",
    "noData": "Aucune donnée",
    "autosaving": "Sauvegarde automatique",
    "connectIntegrate": "Connect & Integrate"
  },
  "genericError": "Oh, quelque chose s'est mal passé ! Veuillez réessayer.",
  "validation": {
    "fieldRequired": "{field} est requis.",
    "fieldNumeric": "Le champ {field} ne peut contenir que des chiffres.",
    "fieldAlpha": "Le champ {field} ne peut contenir que des lettres, _ et -.",
    "fieldAlphanumeric": "Le champ {field} ne peut contenir que des lettres, des chiffres, _ et -.",
    "fieldNumericDash": "Le champ {field} ne peut contenir que des chiffres et -.",
    "fieldHouseNumber": "Le champ {field} ne peut contenir que des chiffres, des lettres et les caractères - et /.",
    "fieldPhoneNumber": "Le champ {field} ne peut contenir que des chiffres et -. Il doit commencer par + ou 00.",
    "fieldAlphaDash": "Le champ {field} ne peut contenir que des lettres et -.",
    "exceptHTMLTagBrackets": "Le champ {field} ne doit pas contenir les caractères suivants : ^<>",
    "isMaxLength": "dépasse la longueur maximale de 10 caractères.",
    "emailFormat": "L'adresse e-mail a un format incorrect",
    "fileSizeError": "La taille du fichier est supérieure à {size} MB.",
    "csvFileSizeError": "Ce fichier est trop volumineux. Vous pouvez télécharger un fichier jusqu'à {size} MB.",
    "csvFileExtensionError": "Seuls les fichiers avec l'extension csv sont autorisés.",
    "csvFileIsEmptyError": "Ce fichier est vide. Vous devez télécharger un fichier d'au moins {size} KB.",
    "csvFileFormatError": "Le fichier ne correspond pas au format attendu. Veuillez utiliser le modèle fourni et réessayer.",
    "uploadFails": "échec du téléchargement",
    "fileExtensionError": "L'extension de fichier n'est pas appropriée",
    "fileIsMalwareInfectedError": "Ce fichier semble contenir des logiciels malveillants. Pour des raisons de sécurité, ce fichier ne peut pas être téléchargé. Veuillez vérifier à nouveau votre fichier",
    "customValidation": "Le {field} a un format incorrect.",
    "selectCountryFirst": "Veuillez d'abord sélectionner le pays",
    "validationPostCodeCaseDE": "Le champ a un format incorrect. Il doit contenir 5 chiffres, par ex., 53113",
    "validationAlphanumericCase": "Le champ ne peut contenir que des caractères alphanumériques, des tirets et des traits de soulignement. La valeur doit commencer par un caractère alphanumérique.",
    "validationNumericDashCase": "Le champ ne peut contenir que des chiffres et -.",
    "url": "Veuillez entrer une URL valide",
    "required": "Ce champ est obligatoire",
    "password": {
      "passwordStrength": "Force du mot de passe",
      "weak": "Faible",
      "average": "Moyen",
      "strong": "Fort",
      "passwordValidationMoreChar": "{count} caractères ou plus",
      "passwordUpperAndLowerChar": "Caractères majuscules et minuscules",
      "passwordAtLeastNumber": "Au moins un chiffre",
      "passwordAtLeastSpecialChar": "Au moins un caractère spécial (sauf <>&\"`[])",
      "passwordDiffFromPrev": "Diffère de vos mots de passe précédents"
    }
  },
  "footer": {
    "tagLine": "Développons de meilleures performances",
    "imprint": "Mentions légales",
    "imprintShort": "Mentions",
    "certifications": "Certifications",
    "imprintLink": "https://dih.telekom.com/fr/imprint",
    "contact": "Contact",
    "contactLink": "https://dih.telekom.com/fr/contact",
    "termsAndConditions": "Conditions générales",
    "privacy": "Politique de confidentialité",
    "privacyShort": "Confidentialité",
    "telekom": "T-Systems International GmbH. Tous droits réservés.",
    "telekomShort": "T-Systems International GmbH",
    "note": "Telekom Data Intelligence Hub - Uniquement pour les clients professionnels",
    "brandedNote": "Propulsé par Telekom Data Intelligence Hub",
    "cookieSettings": "Paramètres des cookies",
    "cookieSettingsShort": "Cookies",
    "life": "La vie est faite pour être partagée"
  },
  "cookieSettings": {
    "collapsedTitle": "Paramètres de confidentialité",
    "collapsedText": "Ce site web utilise des cookies et technologies similaires. Ce sont de petits fichiers texte qui sont stockés et lus sur votre ordinateur. En cliquant sur '{0}', vous acceptez le traitement, la création de profils utilisateur individuels sur des sites web et des partenaires, et le transfert de vos données à des tiers, dont certains traitent vos données dans des pays hors de l'Union européenne (RGPD Art. 49). Les détails se trouvent dans la section '2 de la {1}. Les données sont utilisées pour l'analyse, le reciblage et pour diffuser du contenu personnalisé et de la publicité sur les sites Telekom et des sites tiers. Plus d'informations, y compris des informations sur le traitement des données par des tiers et la possibilité de rétractation, peuvent être trouvées dans les paramètres et dans nos informations sur la confidentialité. Ici, vous pouvez {2} uniquement avec les outils nécessaires.",
    "extendedTitle": "Paramètres de confidentialité",
    "extendedText": "Afin de vous offrir une expérience optimale du site web, nous utilisons des cookies. Ceux-ci incluent des cookies pour le fonctionnement et l'optimisation du site ainsi que pour des services tels que le chat texte ou vidéo et pour la publicité basée sur votre comportement d'utilisation en ligne. Cela nous permet, par exemple, de détecter si vous visitez nos pages de façon répétée depuis le même appareil. Nous aimerions vous donner le choix des cookies que vous autorisez :",
    "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
    "policyLinkTextShort": "informations sur la confidentialité",
    "policyLinkText": "Informations sur la confidentialité",
    "rejectLinkText": "continuer",
    "acceptButton": "Tout accepter",
    "saveButton": "Enregistrer les paramètres",
    "settingsButton": "Modifier les paramètres",
    "showMore": "Afficher plus",
    "showLess": "Afficher moins",
    "categoryTitleEssential": "Cookies nécessaires",
    "categoryTitleAnalytics": "Cookies analytiques",
    "categoryTitleMarketing": "Cookies marketing",
    "categoryTitleThirdParty": "Services d'autres entreprises (fournisseurs tiers indépendants)",
    "categoryTextEssential": "Ces cookies sont nécessaires pour vous permettre de naviguer sur les sites web et d'utiliser les fonctions clés. Ils prennent en charge les fonctions de base, telles que le traitement des commandes dans la boutique en ligne et l'accès aux zones sécurisées du site web. Ils servent également à effectuer une analyse anonyme des modèles d'utilisation, que nous utilisons pour développer et améliorer continuellement nos pages web pour vous.",
    "categoryTextAnalytics": "Ces cookies nous aident à améliorer notre compréhension du comportement des utilisateurs. Les cookies d'analyse permettent la compilation de données d'utilisation et d'identification par le fournisseur original ou des fournisseurs tiers en profils d'utilisation pseudonymes. Nous utilisons des cookies d'analyse par exemple pour déterminer le nombre de visiteurs individuels d'une page web ou d'un service, pour recueillir des données statistiques sur les performances de nos produits et pour analyser les modèles d'utilisation des visiteurs et les interactions des visiteurs sur la base d'informations anonymes et pseudonymes. Ces informations ne peuvent pas être retracées à une personne.",
    "categoryTextMarketing": "Ces cookies et technologies similaires sont utilisés pour permettre l'affichage de contenu marketing personnalisé et donc pertinent. Les cookies marketing sont utilisés pour afficher du contenu publicitaire intéressant et pour mesurer l'efficacité de nos campagnes. Cela se produit non seulement sur les sites web de Telekom, mais aussi sur d'autres sites partenaires publicitaires (fournisseurs tiers). C'est ce qu'on appelle aussi le reciblage. Il est utilisé pour créer des profils de contenu ou d'annonces pseudonymes, pour placer des publicités pertinentes sur d'autres sites web, et pour tirer des enseignements sur les groupes cibles qui ont vu les annonces et le contenu. Ces informations ne peuvent pas être retracées à une personne. Les outils de marketing et de reciblage nous aident à vous proposer du contenu publicitaire potentiellement pertinent pour vous. En supprimant les cookies marketing, vous verrez toujours la même quantité de publicité, mais elle pourrait être moins pertinente pour vous.",
    "categoryTextThirdParty": "Les sites web de Telekom incluent des liens vers des fournisseurs de services tiers, qui fournissent leurs services sous leur propre responsabilité. Lorsque vous visitez les pages web de Telekom, des cookies ou des technologies similaires enregistrent des données et les envoient à des tiers, en partie pour les propres besoins de Telekom. La portée, la finalité et la base juridique sur lesquelles un traitement ultérieur est effectué pour les propres besoins du tiers peuvent être trouvées dans les informations sur la confidentialité des données du tiers. Des informations sur les fournisseurs tiers indépendants peuvent être trouvées dans les informations sur la confidentialité des données."
  },
  "messages": {
    "noDataAvailable": "Aucune donnée disponible",
    "noMatchFound": "Aucune correspondance trouvée",
    "maximumFileSize": "Taille maximale de fichier",
    "suitableFileFormats": "Formats de fichier appropriés",
    "loading": "Chargement...",
    "dragDropText": "ou glissez-déposez ici",
    "noConnectors": "Aucun connecteur trouvé !",
    "comingSoon": "Bientôt disponible"
  },
  "pageNotFound": {
    "title": "Oups ! Il semble que la page que vous recherchez n'existe pas encore.",
    "subtitle": "Consultez nos autres ressources en attendant, qui pourraient vous être utiles !"
  },
  "helpResources": {
    "needHelp": "Besoin d'aide pour trouver le bon plan, plus d'informations, des questions techniques ?",
    "needHelpShorter": "Besoin de plus d'aide ?",
    "developerDoc": "Documentation API",
    "developerDocDesc": "Obtenez la documentation API pour l’automatisation de l’échange de données",
    "example": "Exemple",
    "examples": "Guide d'utilisation",
    "tutorials": "Tutoriels",
    "exampleDescription": "Trouvez des cas d'utilisation et des démos pertinents pour votre secteur industriel",
    "FAQ": "Questions fréquemment posées",
    "FAQDescription": "Trouvez plus de réponses communes de la facturation à la confidentialité",
    "browse": "Parcourir",
    "demos": "Démos",
    "demosDescription": "Trouvez des cas d'utilisation et des démos pertinents pour votre secteur industriel",
    "glossary": "Glossaire",
    "glossaryDescription": "Trouvez les termes et définitions liés à Data Intelligence Hub, IDSA, Catena-X, Gaia-X et plus.",
    "glossaryDescriptionShorter": "Trouvez les termes et définitions de Catena-X, Gaia-X et plus encore",
    "customerSupport": "Support client",
    "customerSupportDesc": "Vous n'avez pas trouvé ce que vous cherchiez ?",
    "contactUs": "Cette fonctionnalité n'est pas prise en charge dans votre abonnement actuel. Veuillez nous contacter pour une mise à niveau.",
    "contactUsBtn": "Nous contacter"
  },
  "basicInfo": {
    "title": "Informations de base",
    "dataspace": "Espace de données",
    "bpn": "Numéro de partenaire commercial"
  },
  "feedbackCard": {
    "title": "Besoin de plus d'aide ?",
    "contactUs": "Contactez-nous"
  },
  "error": {
    "pageNotFound": "Page non trouvée (404)",
    "somethingWrong": "Quelque chose s'est mal passé !",
    "propertyNotFound": "Propriété non trouvée",
    "uniquePropertyName": "Le nom de la propriété doit être unique",
    "dctTypeNotFound": "dct:type non trouvé"
  },
  "helpWidget": {
    "askSupport": "Demander de l'aide",
    "chatboxTitle": "Chat d'aide",
    "chatboxSubtitle": "Support Telekom Data Intelligence Hub",
    "defaultMessage": {
      "body": "Bonjour, bienvenue sur le canal de support Telekom Data Intelligence Hub. Veuillez sélectionner une option ci-dessous."
    },
    "whatCanWeHelpWith": "Comment pouvons-nous vous aider aujourd'hui ?",
    "suggestedAnswers": {
      "knowledgeBase": "Base de connaissances, documentation et FAQs",
      "contactSupport": "Contacter le support",
      "contactSales": "Contacter les ventes"
    }
  },
  "pcfExchange": {
    "title": "Échange PCF",
    "description": "Bienvenue dans la solution d'échange de l'empreinte carbone des produits (PCF) facile à utiliser dans Catena-X.",
    "recentRequests": "Demandes récentes de données PCF",
    "viewAllRequests": "Voir toutes les demandes",
    "requestPcf": "Demander PCF",
    "termCheck": "En soumettant la demande, je comprends que le contrat sera négocié sur l'offre de données selon les politiques définies par le fournisseur de données.",
    "pcfSuccess": "PCF demandé avec succès !",
    "landing": {
      "pcfTitle": "Créer une offre PCF",
      "pcfDesc": "Créez et partagez les données PCF avec les participants du réseau Catena-X.",
      "discoverTitle": "Découvrir et demander des données PCF",
      "discoverDesc": "Recherchez facilement des données PCF dans le réseau Catena-X ou demandez les données PCF à vos partenaires en quelques étapes.",
      "pcfReqTitle": "Demandes de données PCF",
      "pcfReqDesc": "Gérez efficacement les demandes de données PCF de vos partenaires dans le réseau Catena-X.",
      "pcfCalcTitle": "Calculateur PCF",
      "pcfCalcDesc": "Calculez les valeurs PCF et connectez-vous à vos applications ou scénarios d'échange de données PCF sans problème.",
      "pcfHistoryTitle": "Historique d'échange de données PCF",
      "pcfHistoryDesc": "Gagnez en transparence sur votre historique d'échange de données PCF dans le réseau Catena-X et avec vos partenaires.",
      "documentation": "En savoir plus sur l'échange de données PCF",
      "howTo": {
        "description": "Partagez, découvrez et gérez les offres de données d'empreinte carbone des produits (PCF) dans Catena-X.",
        "doc": "Vous voulez en savoir plus sur Connect & Integrate ? Lien de documentation : "
      }
    },
    "requests": {
      "pcfRequests": "Demandes de données PCF",
      "reqDesc": "Utilisez cette zone pour gérer vos demandes de données PCF des partenaires.",
      "productId": "ID du produit*",
      "bpn": "BN*",
      "message": "Message",
      "howTo": {
        "title": "Vous voulez en savoir plus sur le fonctionnement de la gestion des demandes de données PCF ?",
        "description": "Utilisez cette section pour approuver ou rejeter la demande de données PCF de vos partenaires. De plus, consultez les statuts des échanges de données PCF et obtenez une transparence totale dans votre chaîne de données PCF.",
        "doc": "Vous voulez en savoir plus sur le fonctionnement de la négociation et de la consommation des offres de données ?"
      }
    },
    "responses": {
      "howTo": {
        "description": "Découvrez le catalogue d'offres de données d'autres entreprises membres de Catena-X. Vous pouvez rechercher, sélectionner et vous abonner à une offre de données. Vous pouvez rechercher des offres de données en utilisant le nom de l'entreprise ou avec l'ID de pièce du fabricant ou avec une combinaison des deux."
      }
    },
    "view": {
      "title": "Voir les détails PCF"
    }
  },
  "pcfExchangeV9": {
    "landing": {
      "pcfReqTitle": "PCF Provider",
      "pcfHistoryTitle": "PCF Consumer"
    },
    "aspects": {
      "title": "Aspects PCF",
      "description": "Consultez toutes les valeurs et tous les aspects PCF que vous avez fournis.",
      "cardDescription": "Consultez toutes les valeurs et tous les aspects PCF que vous avez déjà fournis, avant même leur échange.",
      "responses": "Réponses",
      "assets": "Actifs"
    },
    "incomingRequests": "Demandes PCF entrantes",
    "sentResponses": "Réponses PCF envoyées",
    "sentRequests": "Demandes PCF envoyées",
    "incomingResponses": "Réponses PCF entrantes",
    "requests": {
      "pcfRequests": "PCF Provider",
      "partIdDescription": "Fournissez soit l'ID de pièce du fabricant, soit l'ID de pièce du client. Au moins l'un d'eux est requis.",
      "manufacturerPartId": "ID de pièce du fabricant",
      "customerPartId": "ID de pièce du client",
      "eitherPartIdRequired": "L'ID de pièce du fabricant ou l'ID de pièce du client est requis."
    }
  },
  "cyberSecurityKPIs": {
    "title": "Indicateurs de cybersécurité",
    "historyTitle": "Historique des métriques de cybersécurité envoyé",
    "historySubTitle": "Ici vous pouvez voir l'historique des données partagé",
    "description": "Bienvenue dans le partage de données de cybersécurité facile à utiliser avec vous, un fabricant",
    "nothinghere": "Rien ici pour l'instant !",
    "newEntryAppearance": "Lorsque vous créerez une nouvelle entrée, elle apparaîtra ici.",
    "createKPITitle": "Créer et envoyer des indicateurs de cybersécurité",
    "createKPISubTitle": "Merci de remplir tous les détails d'un coup. Les données ne seront pas sauvegardées si vous choisissez d'annuler avant d'envoyer. Si vous choisissez d'annuler, vous serez redirigé vers le tableau de bord des cas d'utilisation et vous devrez remplir les détails dès le début.",
    "createKPIDocumentationDesclaimer": "Pour plus d'informations sur la façon de remplir le formulaire et les autres exigences du fabricant, veuillez suivre notre {documentation}.",
    "documentation": "Documentation",
    "generalInformation": "Informations générales",
    "measurementYear": "Année de mesure",
    "receiverBpn": "BPN du récepteur",
    "confirmationText": "En soumettant la demande, je comprends que le contrat sera négocié sur l'offre de données conformément aux politiques établies par le fournisseur de données.",
    "successTitle": "Succès",
    "successDescription": "Vos données sont partagées avec succès. Job id est {id}",
    "sendMetricsFailed": "Erreur dans le partage de vos données.",
    "kpiKnowledgeBase": "En savoir plus sur le cas d'utilisation",
    "kpiFirstEntry": "Commencez et créez votre première entrée",
    "metricsInformation": {
      "title": "Informations sur les métriques",
      "measurementDate": "Date de mesure",
      "value": "valeur",
      "kpiNotSharedReason": "Raison de ne pas partager la métrique",
      "enclosedSiteTitle": "Sites enclos,",
      "enclosedSiteLabel": "Sélectionnez vos sites enclos."
    },
    "modal": {
      "leaveTitle": "Partir sans sauvegarder ?",
      "leaveDescription": "Si vous fermez ce formulaire maintenant, vos données saisies seront perdues.",
      "discardBtn": "Supprimer les modifications",
      "continueEditingBtn": "Continuer l'édition",
      "confirmTitle": "Confirmer l'envoi",
      "confirmDescription": "Une fois envoyé, ce message ne peut être modifié ni rappelé.",
      "confirmReviewBtn": "Réviser à nouveau"
    },
    "helpCard": {
      "title": "Comment ça fonctionne ?",
      "description": "Partagez les données annuelles des KPI de cybersécurité avec BMW. Obtenez ici une vue d’ensemble complète de toutes les informations précédemment enregistrées.",
      "subtitle": "Vous souhaitez en savoir plus sur le cas d’usage des métriques de cybersécurité ?"
    },
    "metricsViewer": {
      "jobId": "ID de tâche",
      "threadId": "ID de thread",
      "stepId": "D de pas",
      "header": "En-têtes",
      "messageId": "ID de messageD",
      "senderBpn": "BPN de l'expéditeur",
      "receiverBpn": "BPN du récepteur",
      "senderFeedbackUrl": "URL de retour de l'expéditeur",
      "content": "Contenu",
      "reportId": "ID de rapport",
      "kpiShared": "KPI partagé"
    }
  },
  "publicationTemplates": {
    "title": "Mes modèles de publication",
    "deletedTemplates": "Mes modèles supprimés",
    "showDeletedTemplates": "Afficher les modèles supprimés",
    "hideDeletedTemplates": "Afficher les modèles actifs",
    "newTemplate": "Nouveau modèle",
    "create": {
      "title": "Créer un modèle de publication",
      "edit": "Modifier le modèle de publication",
      "templateName": "Nom du modèle",
      "templateType": "Modèle de {type}",
      "create": "Créer",
      "update": "Mettre à jour",
      "modifiedAt": "Modifié le",
      "accessPolicyId": "Politique d'accès",
      "usagePolicyId": "Politique d'utilisation",
      "isEnabled": "Est activé",
      "targetCompany": "Entreprise cible",
      "targetConnectors": "Connecteurs cibles",
      "selectCountry": "Sélectionner un pays",
      "templateDetails": "Détails du modèle de publication",
      "assetsCriteria": "Critères de sélection d'actifs",
      "connectorDetails": "Détails du connecteur"
    },
    "delete": {
      "title": "Supprimer le modèle de publication",
      "description": "Êtes-vous sûr de vouloir supprimer ce modèle ?",
      "button": "Supprimer"
    }
  },
  "contracts": {
    "title": "Détails des accords contractuels",
    "provider": {
      "description": "Voici un aperçu des accords contractuels que votre organisation a avec d'autres participants à l'espace de données.",
      "note": "Veuillez noter que la liste ci-dessous affiche les données de tous les cas d'utilisation. Nous introduirons bientôt une liste de données pré-filtrée ainsi qu'une recherche et un filtrage avancés par cas d'utilisation. En attendant, veuillez utiliser les options de recherche et de filtrage pour trouver les données pertinentes dans la liste ci-dessous.",
      "howItWorks": {
        "description": "Ici, vous pouvez trouver tous vos accords de données souscrits ou négociés dans divers espaces de données. Vous pouvez filtrer les résultats pour un connecteur particulier ou simplement rechercher avec un ID d'accord contractuel ou un ID d'actif. Vous pouvez également trier la liste pour voir les accords de données selon vos besoins. De plus, vous pouvez sélectionner les offres de données et les exporter localement si vous le souhaitez.",
        "subtitle": "Vous voulez en savoir plus sur le fonctionnement de la négociation et de la consommation des offres de données ?"
      },
      "details": {
        "title": "Détails des accords contractuels fournis",
        "description": "Description",
        "content": "Contenu",
        "agreementDetails": "Détails de l'accord",
        "assetDetails": "Détails de l'actif",
        "usagePolicy": "Politique d'utilisation"
      }
    },
    "consumer": {
      "description": "Voici un aperçu des accords contractuels que votre organisation a pour les offres de données d'autres participants à l'espace de données ",
      "downloadData": "Télécharger les données",
      "downloadAgreement": "Télécharger l'accord",
      "reinitiate": "Initier le transfert et télécharger les données",
      "error": {
        "heading": "Désolé ! Il semble que vous ayez déjà négocié ce contrat.",
        "body": "Vous ne pouvez pas renégocier un contrat déjà négocié. Vous pouvez trouver les détails du contrat ci-dessous et vous pouvez également télécharger cet accord et souscrire aux données."
      },
      "details": {
        "title": "Détails des accords contractuels consommés"
      },
      "howItWorks": {
        "description": "Ici, vous pouvez trouver tous vos accords de données souscrits ou négociés dans divers espaces de données. Vous pouvez filtrer les résultats pour un connecteur particulier ou simplement rechercher avec un ID d'accord contractuel ou un ID d'actif. Vous pouvez également trier la liste pour voir les accords de données selon vos besoins. De plus, vous pouvez sélectionner les offres de données et les exporter localement si vous le souhaitez.",
        "subtitle": "Vous voulez en savoir plus sur le fonctionnement de la négociation et de la consommation des offres de données ?"
      }
    }
  },
  "provider": {
    "provider": "Fournisseur",
    "assets": {
      "title": "Mes actifs",
      "offeredBy": "Offert par :",
      "offers": "Offres",
      "created": "Créé",
      "modifiedAt": "Modifié le",
      "noResultsFound": "Aucun actif trouvé",
      "success": "Actif créé avec succès",
      "updateSuccess": "Actif mis à jour avec succès",
      "buttons": {
        "createOffer": "Créer une offre",
        "details": "Voir les détails",
        "delete": "Supprimer l'actif",
        "create": "Créer un actif",
        "edit": "Modifier l'actif",
        "update": "Mettre à jour l'actif",
        "showDeleted": "Afficher les actifs supprimés",
        "hideDeleted": "Masquer les actifs supprimés",
        "restore": "Restaurer l'actif",
        "add": "Ajouter une paire clé-valeur",
        "addJson": "Ajouter un objet json",
        "editJson": "Modifier l'objet json",
        "saveJson": "Enregistrer JSON",
        "advanceAddition": "Ajout avancé",
        "unpublish": "Actif non publié",
        "showAssets": "Afficher les actifs"
      },
      "detailsDialog": {
        "title": "Détails de l'actif"
      },
      "createDialog": {
        "title": {
          "general": "Créer un nouvel actif",
          "edit": "Modifier l'actif",
          "addProperties": "Ajouter des propriétés",
          "advance": "Ajout de propriété avancé"
        },
        "publicProps": "Propriétés publiques",
        "privateProps": "Propriétés privées",
        "dataAddress": "Adresse de données",
        "dataSources": "Source de données",
        "dataDestination": "Destination des données",
        "json": {
          "fields": "Champs Json",
          "editor": "Éditeur de propriétés personnalisées",
          "formatted": "Visualiseur de propriétés personnalisées",
          "error": "JSON invalide :",
          "placeholder": "Saisissez le JSON des propriétés personnalisées"
        },
        "connectionTypeLabel": {
          "http": "Saisir l’URL",
          "s3": "Saisir le nom de l’objet",
          "azure": "Saisir le nom du blob",
          "sftp": "Saisir le nom du fichier"
        },
        "fields": {
          "name": "Nom",
          "namePlaceholder": "Entrez le nom de l'offre",
          "description": "Description",
          "version": "Version",
          "contentType": "Type de contenu",
          "contentTypePlaceholder": "Entrez le type de contenu",
          "keywords": "Mots-clés",
          "language": "Langue",
          "languagePlaceholder": "Sélectionnez la langue",
          "semanticId": "ID sémantique",
          "semanticIdPlaceholder": "Veuillez insérer l'ID sémantique",
          "dct:type": "dt:type",
          "dct:typePlaceholder": "Choisissez un type dct",
          "keywordsPlaceholder": "Ajouter des mots-clés",
          "descriptionPlaceholder": "Écrivez la description de l'offre",
          "versionPlaceholder": "Numéro de version",
          "dataType": "Type d'adresse de données",
          "dataTypePlaceholder": "Sélectionnez le type d'adresse de données",
          "dataAddressUrl": "URL de l'actif",
          "dataAddressUrlPlaceholder": "Entrez l'URL de l'actif",
          "targetCompany": "Entreprise cible",
          "targetCompanyPlaceholder": "Insérez une entreprise cible",
          "country": "Pays",
          "countryPlaceholder": "Insérez un pays",
          "key": "Clé",
          "keyPlaceholder": "Entrez la clé",
          "value": "Valeur",
          "valuePlaceholder": "Entrez la valeur",
          "assetType": "Type d'actif",
          "assetTypePlaceholder": "Entrez le type d'actif"
        },
        "validation": {
          "name": "Veuillez entrer un nom",
          "assetType": "Veuillez sélectionner un type d'actif",
          "contentType": "Veuillez entrer un type de contenu valide",
          "dataType": "Veuillez sélectionner un type de données valide",
          "targetCompany": "Veuillez entrer une entreprise cible valide",
          "country": "Veuillez entrer un pays valide"
        }
      },
      "tags": {
        "restricted": "Accès restreint",
        "unrestricted": "Sans restriction"
      },
      "search": {
        "title": "Filtres de recherche",
        "helperText": "Rechercher par nom d'actif, date de création ou type",
        "filters": {
          "byName": "Nom de l'actif",
          "byType": "Type d'actif",
          "byDate": "Date de modification",
          "byAssetId": "ID d'actif"
        }
      },
      "delete": {
        "title": "Supprimer l'actif",
        "description": "Êtes-vous sûr de vouloir supprimer cet actif ?"
      },
      "unpublish": {
        "title": "Actif non publié",
        "description": "Êtes-vous sûr de vouloir déposer cet actif?"
      }
    },
    "fileUploadTerms": "Je comprends et confirme que j'ai correctement rempli toutes les informations requises et T-Systems n'est pas responsable en cas d'informations incorrectes et de rejet d'offre.",
    "fileUploadInfo": "T-Systems ne vérifie pas la validité des informations de métadonnées renseignées ici. Veuillez vous assurer que vous avez fourni des informations correctes et complètes.",
    "pdf": "PDF",
    "csv": "CSV",
    "singleEntry": "Entrée unique",
    "bulkEntries": "Entrées en masse"
  },
  "home": {
    "title": "Connectez-vous et intégrez",
    "welcomeBack": "Bon retour"
  },
  "gettingStarted": {
    "title": "Besoin d'aide pour commencer ?",
    "openWizard": "Ouvrir l'assistant",
    "yourDataOffering": "Votre offre de données",
    "yourAssets": "Actifs",
    "yourPolicies": "Mes politiques",
    "preconfiguredCatalogue": "Catalogue préconfiguré",
    "contractAgreements": "Accords contractuels",
    "incomingAgreements": "Accords entrants",
    "outgoingAgreements": "Accords sortants",
    "connectors": "Vos connecteurs",
    "providedAgreements": "Accords contractuels fournis",
    "consumedAgreements": "Accords contractuels consommés",
    "totalContracts": "Nombre total de contrats"
  },
  "yourConnection": {
    "title": "Vos connecteurs",
    "viewAllConnection": "Voir tous les connecteurs",
    "help": "Aide",
    "documentation": "Découvrez votre Connect & Integrate",
    "gettingStarted": "Guide de démarrage",
    "noUseCases": "Aucun cas d'utilisation disponible",
    "activeUseCases": "Cas d’utilisation actifs",
    "useCasesAvailableToActivate": "Cas d’utilisation disponibles à activer",
    "open": "Ouvrir",
    "show": "Afficher",
    "pcfVersionModal": {
      "title": "Versions d'échange PCF",
      "description": "Connect & Integrate prend en charge les versions PCF et déploiements de règlements suivants pour l'échange PCF au sein du réseau Catena-X. Veuillez sélectionner votre option préférée. Veuillez noter que les deux versions ne sont pas connectées.",
      "current": "Actuelle",
      "deprecated": "Obsolète",
      "rulebook": "Règlement",
      "pcfSubmodel": "Sous-modèle PCF",
      "supportStatus": "Statut du support",
      "statusActive": "Actif",
      "statusEol": "Fin de vie",
      "saturn": {
        "name": "Saturn",
        "description": "Dernière version avec fonctionnalités améliorées et prise en charge complète des normes actuelles de durabilité. Recommandée pour tous les déploiements."
      },
      "jupiter": {
        "name": "Jupiter",
        "description": "Version héritée maintenue pour la compatibilité ascendante. Migration vers Saturn fortement recommandée avant la fin de la période de support."
      }
    }
  },
  "wizardSelectionPopup": {
    "whatToLike": "Que souhaitez-vous faire aujourd'hui ?",
    "prepare": "Préparer",
    "govern": "Gouverner",
    "provide": "Fournir",
    "consume": "Consommer",
    "howToProvide": "Comment souhaitez-vous fournir des données aujourd'hui ?",
    "manual": "Manuel",
    "automated": "Automatisé via une API",
    "selectUseCases": "Sélectionnez vos cas d'utilisation",
    "selectSingleUseCase": "Sélectionnez votre cas d'utilisation",
    "selectDigitalTwin": "Sélectionnez votre type de jumeau numérique",
    "back": "Retour",
    "publish": "Je comprends les exigences du cadre de l'espace de données et j'accepte de publier l'offre de données dans l'espace de données au nom de mon organisation."
  },
  "createOffer": {
    "title": {
      "standard": "Créer une offre de données",
      "pcf": "Créer une offre de données PCF",
      "certificate": "Créer une offre de certificat",
      "traceability": "Créer une offre de données de Traçabilité"
    },
    "publish": "Publier",
    "legalConfirmation": "Je comprends les exigences du cadre de l'espace de données et j'accepte de publier l'offre de données dans l'espace de données au nom de mon organisation.",
    "wizard": {
      "provisionAsset": "Provisionner l'actif",
      "dataUpload": "Sélection des données",
      "attachPolicy": "Attacher une politique",
      "publishDataOffer": "Publier l'offre de données"
    },
    "provisionAsset": {
      "howToSelectSubmodel": "Pour quel sous-modèle souhaitez-vous créer une offre de données ?",
      "selectSubmodel": "Sélectionner un sous-modèle",
      "selectUsecase": "Sélectionner un cas d'utilisation",
      "selectDigitalTwinType": "Sélectionner un type de jumeau numérique",
      "whichTypeToSelect": "Quel type dois-je sélectionner ?",
      "generalInformation": "Informations générales",
      "description": "Description",
      "contentType": "Type de contenu",
      "keywords": "Mots-clés",
      "language": "Langue",
      "location": {
        "title": "Localisation et adressage",
        "text": "Veuillez saisir les détails de votre actif"
      },
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "assetUrl": "URL de l'actif",
      "assetUrlPlaceHolder": "Veuillez insérer l'URL de votre actif",
      "clientId": "ID client",
      "clientSecret": "Secret client",
      "tokenUrl": "URL du jeton",
      "tokenUrlPlaceHolder": "Veuillez insérer votre URL de jeton",
      "provideAssets": "Fournir un actif",
      "selectConnectorLabel": "Sélectionnez les connecteurs avec lesquels vous souhaitez partager vos données",
      "selectConnectorPlaceholder": "Sélectionner un connecteur",
      "selectRestApiType": "Sélectionner le type d'API REST",
      "selectedAuthMethod": "Méthode d'authentification"
    },
    "dataUpload": {
      "selectUploadType": "Sélectionnez votre type de téléchargement",
      "selectedDataModel": "Sélectionner vos données",
      "csvUpload": {
        "title": "Fichier CSV",
        "description": "Glissez-déposez vos fichiers ici",
        "uploadFile": "Sélectionner un fichier",
        "uploadFileDescription": "Préparez et téléchargez le fichier que vous souhaitez échanger. Vous pouvez télécharger le fichier exemple pour vous aider à démarrer avec le format requis pour Catena-X.",
        "uploadFileDescriptionNote1": "Téléchargez le fichier modèle à partir du lien ci-dessous",
        "uploadFileDescriptionNote2": "Remplissez le fichier fourni avec les détails de vos partenaires",
        "uploadFileDescriptionNote3": "Téléchargez le fichier dans la zone prévue",
        "partnerValidationNote": "Si vous souhaitez en savoir plus sur la validation des partenaires, veuillez",
        "clickHere": "cliquer ici",
        "downloadTemplate": "Télécharger le modèle",
        "downloadSampleCsv": "Télécharger l'exemple de CSV",
        "supportedFileTypes": "Types de fichiers pris en charge :"
      },
      "jsonUpload": {
        "title": "JSON",
        "submodelJson": "JSON du sous-modèle",
        "downloadTemplate": "Télécharger le modèle",
        "downloadSampleJson": "Télécharger l'exemple de JSON",
        "uploadFileDescription": "Préparez et téléchargez le fichier que vous souhaitez échanger.",
        "invalidJson": "Le contenu fourni n'est pas un JSON valide. Veuillez vérifier la saisie et réessayer.",
        "schemaValidationFailed": "Échec de la validation du schéma Catena-X",
        "issue": "problème",
        "issues": "problèmes"
      },
      "operationMode": {
        "title": "Sélectionner le mode d'opération",
        "description": "Décidez maintenant comment la coque de ce jumeau est obtenue.",
        "createNew": {
          "title": "Créer un nouveau jumeau numérique",
          "description": "Enregistrer une nouvelle coque AAS dans CX-Core"
        },
        "useExisting": {
          "title": "Utiliser un jumeau numérique existant",
          "description": "Lier à une coque déjà présente dans CX-Core"
        }
      },
      "useExisting": {
        "searchTitle": "Rechercher une coque existante dans CX-Core",
        "catenaXId": "ID Catena-X",
        "search": "Rechercher",
        "reset": "Réinitialiser",
        "noResults": "Aucun jumeau numérique correspondant trouvé.",
        "searchError": "Échec de la recherche de jumeaux numériques. Veuillez réessayer.",
        "matchingTypeNote": "Seules les coques correspondant au type de jumeau numérique sélectionné sont répertoriées.",
        "propertiesTitle": "Propriétés du jumeau numérique",
        "readOnly": "(lecture seule)"
      },
      "digitalTwinProperties": {
        "title": "Propriétés du jumeau numérique",
        "specificAssetIds": "ID d'actifs spécifiques"
      },
      "tableUpload": {
        "title": "Tableau",
        "description": "Fournir des entrées de table personnalisées",
        "add": "Ajouter"
      },
      "fileUpload": {
        "title": "Téléchargement de fichier",
        "description": "csv, json"
      },
      "objectStorage": {
        "title": "Stockage d'objets",
        "description": "AWS, Azure, OTC ou GCP"
      },
      "sftp": {
        "title": "Serveur SFTP",
        "description": "transfert via SFTP"
      },
      "apiUpload": {
        "title": "API REST",
        "description": "transfert via API",
        "authAndIdentiTitle": "Authentification et identification",
        "authAndIdentiDesc": "Veuillez saisir les détails d'authentification de votre système de destination",
        "selectApiType": "Sélectionner le type d'API REST",
        "locationAndAddrTitle": "Localisation et adressage",
        "locationAndAddrDesc": "Veuillez saisir les détails de votre actif",
        "assetUrl": "URL de l'actif",
        "username": "Nom d'utilisateur",
        "password": "Mot de passe",
        "clientId": "ID client",
        "clientSecret": "Secret client"
      }
    },
    "fileUpload": {
      "title": "Glissez et déposez votre fichier ici",
      "btnText": "Sélectionner un fichier"
    },
    "attachPolicy": {
      "title": "Attacher une politique à cette offre de données",
      "createPolicy": "Créer une nouvelle politique",
      "bpnFieldTitle": "Avec qui voulez-vous échanger vos données ?",
      "howItWork": {
        "title": "Comment ça marche ?",
        "description": "Nous préconfigurons les politiques basées sur l'accord-cadre du cas d'utilisation Catena-X. L'accès à vos données ne sera autorisé que pour les numéros de partenaires commerciaux fournis.",
        "knowMore": "Vous voulez en savoir plus sur les politiques ?",
        "documentation": "Documentation"
      },
      "accessPolicyTableText": "Attacher une politique d'accès à cette offre de données",
      "usagePolicyTableText": "Attacher une politique d'utilisation à cette offre de données",
      "heading": {
        "title": "Attacher des politiques existantes ou en créer de nouvelles",
        "description": "Veuillez attacher à la fois une politique d'accès et d'utilisation à partir des tableaux ci-dessous pour terminer la publication de l'offre de données. Vous pouvez également rechercher des politiques par leurs noms ou créer une nouvelle politique au cas où vous n'auriez pas encore la politique souhaitée."
      }
    },
    "publishDataOffer": {
      "dataOfferDetails": "Détails de l'offre de données",
      "generalInformation": "Informations générales",
      "attribute": "Attribut",
      "value": "Valeur",
      "knowMore": "En savoir plus sur votre offre de données",
      "attachedDataAssets": "Éléments attachés",
      "attachedPolicies": "Politiques attachées",
      "allowPolicyPublish": "J'autorise la publication de la politique",
      "publish": "Publier",
      "verifiedLegalEntity": "Entité juridique vérifiée par",
      "dataOfferCreatedBy": "Offre de données créée par : ",
      "contactOrgAdmin": "Contacter l'administrateur de l'organisation",
      "help": "Aide",
      "attachedDataAsset": "Actif de données attaché",
      "attachedAccessPolicy": "Politique d'accès attachée",
      "attachedUsagePolicy": "Politique d'utilisation attachée",
      "publishedConnectors": "Connecteurs auxquels cette offre sera publiée",
      "knowMoreConnector": "En savoir plus sur vos connecteurs",
      "knowMorePolicies": "En savoir plus sur vos politiques",
      "knowMoreDataAssets": "En savoir plus sur vos actifs de données",
      "knowMoreDataOffers": "En savoir plus sur votre offre de données",
      "publishCheckboxLabel": "Je, au nom de mon organisation, accepte de publier l'offre de données et les actifs dans l'espace de données. Je confirme l'utilisation des politiques associées pour gouverner l'espace de données et les politiques associées et je suivrai le cadre de l'espace de données pour toute opération sur l'offre et les actifs une fois publiés."
    },
    "result": {
      "success": {
        "title": "Demande réussie.",
        "description": "Processus de publication d'actif démarré ! L'ID du job est {id}"
      }
    },
    "success": {
      "title": "Votre offre de données est maintenant publiée",
      "description": "Votre offre de données est maintenant publiée, cliquez sur ce qui suit pour les prochaines étapes",
      "createOffer": "Créer une autre offre de données",
      "createOfferButton": "Créer",
      "goToHome": "Aller à l'accueil",
      "goToHomeButton": "Aller à l'accueil",
      "uploadHistory": "Vérifier votre historique de téléchargements"
    }
  },
  "policy": {
    "newPolicy": "Nouvelle politique",
    "showDeletedPolicies": "Afficher les politiques supprimées",
    "myDeletedPolicies": "Mes politiques supprimées",
    "hideDeletedPolicies": "Afficher les politiques actives",
    "restoreAsset": "Restaurer",
    "publishDeletion": "Publier la suppression",
    "create": {
      "title": "Créer une nouvelle politique",
      "edit": "Modifier la politique",
      "policyName": "Nom de la politique",
      "policyType": "Politique de {type}",
      "accessPolicy": "Politique d'accès",
      "usagePolicy": "Politique d'utilisation",
      "create": "Créer et enregistrer",
      "update": "Mettre à jour"
    },
    "delete": {
      "title": "Supprimer la politique",
      "description": "Êtes-vous sûr de vouloir supprimer cette politique ?",
      "button": "Supprimer"
    },
    "types": {
      "BusinessPartnerNumber": {
        "title": "Numéro de partenaire commercial",
        "description": "La restriction du numéro de partenaire commercial peut être utilisée pour définir quels partenaires commerciaux exacts (sur la base de BPNL) sont autorisés à consulter ou à négocier l'offre de données respective. "
      },
      "BusinessPartnerGroup": {
        "title": "Groupe de partenaires commerciaux",
        "description": "La restriction de groupe de partenaires commerciaux peut être utilisée pour définir quels partenaires commerciaux exacts (sur la base de BPNL) sont autorisés à consulter ou à négocier l'offre de données respective. "
      },
      "Membership": {
        "title": "Adhésion",
        "description": "Les informations d'identification d'adhésion peuvent être utilisées pour garantir que seuls les membres CX sont autorisés à consulter ou à négocier l'offre de données respective."
      },
      "ContractReference": {
        "title": "Référence du contrat",
        "description": "La restriction de référence du contrat peut être utilisée pour définir les détails du contrat bilatéral dans lesquels les données sont partagées. "
      },
      "Dismantler": {
        "title": "Démantèleur",
        "description": "Les entreprises détentrices du titre sont des entreprises certifiées en matière de démantèlement.",
        "allowedBrands": {
          "title": "Marques autorisées du démantèleur",
          "description": "Rôle d'entreprise définissant un démantèleur. Les entreprises détentrices du titre sont des entreprises certifiées en matière de démantèlement."
        }
      },
      "UsagePurpose": {
        "title": "Objectif d'utilisation",
        "description": "Objectif d'utilisation"
      },
      "FrameworkAgreement": {
        "title": "Accord-cadre",
        "description": "Avec le FrameworkAgreement Credential, seuls les participants qui ont signé l'accord-cadre respectif (général ou via une version spécifique) sont autorisés à consulter ou à négocier l'offre de données respective. "
      },
      "Duration": {
        "title": "Durée",
        "description": "Durée d'utilisation des données à partir de la date de signature."
      },
      "inForceDate": {
        "title": "Plage de dates fixe",
        "description": "Période de date fixe pour l’utilisation des données."
      },
      "connector": {
        "title": "Restriction du connecteur",
        "description": "Entreprises détenant les connecteurs à utiliser pour leur restriction."
      },
      "AffiliatesBpnl": {
        "title": "Affiliés",
        "description": "Documente (ne vérifie pas) les partenaires commerciaux affiliés."
      },
      "AffiliatesRegion": {
        "title": "Région des affiliés",
        "description": "Documente (ne vérifie pas) les régions des affiliés."
      },
      "ConfidentialInformationMeasures": {
        "title": "Mesures relatives aux informations confidentielles",
        "description": "Documente (ne vérifie pas) si des mesures de confidentialité doivent être prises."
      },
      "ConfidentialInformationSharing": {
        "title": "Partage d'informations confidentielles",
        "description": "Documente (ne vérifie pas) si des mesures de confidentialité doivent être prises."
      },
      "ContractTermination": {
        "title": "Résiliation du contrat",
        "description": "Documente (ne vérifie pas) ce que le consommateur doit faire avec les données après la résiliation du contrat."
      },
      "DataFrequency": {
        "title": "Fréquence des données",
        "description": "Documente (ne vérifie pas) la fréquence à laquelle l'actif peut être transféré."
      },
      "DataProvisioningEndDate": {
        "title": "Fin de fourniture des données",
        "description": "Documente (ne vérifie pas) une date absolue à laquelle la fourniture de l'actif prend fin."
      },
      "DataProvisioningEndDurationDays": {
        "title": "Jours de fourniture des données",
        "description": "Documente (ne vérifie pas) la durée de fourniture de l'actif."
      },
      "DataUsageEndDate": {
        "title": "Fin d'utilisation des données",
        "description": "Documente (ne vérifie pas) une date absolue à laquelle la consommation de l'actif prend fin."
      },
      "DataUsageEndDurationDays": {
        "title": "Jours d'utilisation des données",
        "description": "Documente (ne vérifie pas) la durée de consommation de l'actif."
      },
      "DataUsageEndDefinition": {
        "title": "Définition de la fin d'utilisation des données",
        "description": "Documente (ne vérifie pas) la durée de consommation de l'actif."
      },
      "JurisdictionLocation": {
        "title": "Lieu de juridiction",
        "description": "Documente (ne vérifie pas) la juridiction de ce contrat en texte clair"
      },
      "JurisdictionLocationReference": {
        "title": "Référence du lieu de juridiction",
        "description": "Documente (ne vérifie pas) la juridiction de ce contrat par rapport aux parties impliquées"
      },
      "Liability": {
        "title": "Responsabilité",
        "description": "Documente (ne vérifie pas) la responsabilité de ce contrat envers les parties impliquées"
      },
      "ManagedLegalEntityBpnl": {
        "title": "Entité juridique gérée",
        "description": "Documente (ne vérifie pas) les partenaires commerciaux pour lesquels le fournisseur gère l'actif."
      },
      "ManagedLegalEntityRegion": {
        "title": "Région de l'entité juridique gérée",
        "description": "Documente (ne vérifie pas) la région pour laquelle le fournisseur gère l'actif."
      },
      "Precedence": {
        "title": "Priorité",
        "description": "Documente (ne vérifie pas) quel cadre contractuel a la priorité"
      },
      "ExclusiveUsage": {
        "title": "Utilisation exclusive",
        "description": "Documente (ne vérifie pas) que cet actif est offert exclusivement au consommateur"
      },
      "UsageRestriction": {
        "title": "Restriction d'utilisation",
        "description": "Documente (ne vérifie pas) ce que le consommateur ne peut pas faire avec cet actif"
      },
      "VersionChanges": {
        "title": "Changements de version",
        "description": "Documente (ne vérifie pas) le type de changements de version qui peuvent survenir sur l'actif"
      },
      "Warranty": {
        "title": "Garantie",
        "description": "Documente (ne vérifie pas) la garantie que le consommateur obtient pour l'actif"
      },
      "WarrantyDefinition": {
        "title": "Définition de la garantie",
        "description": "Documente (ne vérifie pas) la période de garantie que le consommateur obtient pour l'actif"
      },
      "WarrantyDurationMonths": {
        "title": "Durée de la garantie",
        "description": "Documente (ne vérifie pas) la période de garantie que le consommateur obtient pour l'actif en mois."
      }
    },
    "fields": {
      "BusinessPartnerNumber": "Numéro de partenaire commercial",
      "tx:BusinessPartnerGroup": "Groupe de partenaires commerciaux",
      "cx-policy:Membership": "Adhésion",
      "cx-policy:ContractReference": "Référence du contrat",
      "cx-policy:Dismantler.allowedBrands": "Marques autorisées du démantèleur",
      "cx-policy:Dismantler": "Démanteleur",
      "cx-policy:UsagePurpose": "Objectif d'utilisation",
      "cx-policy:FrameworkAgreement": "Accord-cadre",
      "duration": "Durée",
      "unit": "Unité",
      "fromdate": "À partir de la date",
      "todate": "À ce jour",
      "connector": "Connecteur",
      "cx-policy:AffiliatesBpnl": "Affiliés",
      "cx-policy:AffiliatesRegion": "Région des affiliés",
      "cx-policy:ConfidentialInformationMeasures": "Mesures relatives aux informations confidentielles",
      "cx-policy:ConfidentialInformationSharing": "Partage d'informations confidentielles",
      "cx-policy:ContractTermination": "Résiliation du contrat",
      "cx-policy:DataFrequency": "Fréquence des données",
      "cx-policy:DataProvisioningEndDate": "Fin de fourniture des données",
      "cx-policy:DataProvisioningEndDurationDays": "Jours de fourniture des données",
      "cx-policy:DataUsageEndDate": "Fin d'utilisation des données",
      "cx-policy:DataUsageEndDurationDays": "Jours d'utilisation des données",
      "cx-policy:DataUsageEndDefinition": "Définition de la fin d'utilisation des données",
      "cx-policy:JurisdictionLocation": "Lieu de juridiction",
      "cx-policy:JurisdictionLocationReference": "Référence du lieu de juridiction",
      "cx-policy:Liability": "Responsabilité",
      "cx-policy:ManagedLegalEntityBpnl": "Entité juridique gérée",
      "cx-policy:ManagedLegalEntityRegion": "Région de l'entité juridique gérée",
      "cx-policy:Precedence": "Priorité",
      "cx-policy:ExclusiveUsage": "Utilisation exclusive",
      "cx-policy:UsageRestriction": "Restriction d'utilisation",
      "cx-policy:VersionChanges": "Changements de version",
      "cx-policy:Warranty": "Garantie",
      "cx-policy:WarrantyDefinition": "Définition de la garantie",
      "cx-policy:WarrantyDurationMonths": "Durée de la garantie"
    }
  },
  "jobs": {
    "jobs": "Emplois",
    "allApplicationsNote": "Cette vue affiche les journaux de toutes les applications. L'historique des journaux propre à chaque application sera bientôt disponible.",
    "name": "Nom",
    "startedAt": "Commencé à",
    "duration": "Durée",
    "jobDetails": "Détails du processus",
    "reload": "Recharger",
    "noDetailsAvailable": "Aucun détail supplémentaire disponible pour ce job",
    "retry": "Réessayer"
  },
  "search-offer": {
    "pageTitle": "Rechercher des offres de données",
    "pcfTitle": "Rechercher des offres de données PCF",
    "pcfV9Title": "Rechercher des offres de données PCF v9",
    "certificateTitle": "Rechercher des offres de certificats de partenaires commerciaux",
    "filter": {
      "bpnSearch": "Rechercher par votre numéro de partenaire commercial ou un nom d'entreprise",
      "bpnSearchNote": "Trouvez les offres de données en recherchant avec le nom de l'entreprise ou le BPN.",
      "manufacturePartId": "ID de pièce du fabricant",
      "manufacturePartIdNote": "Recherche toutes les offres de données correspondant à l'ID de pièce donné.",
      "enter": "Entrer {field}",
      "connectorUrl": "URL du connecteur",
      "connectorUrlNote": "Rechercher des données dans des connecteurs spécifiques",
      "subModel": "Sous-modèle",
      "subModelNote": "Affinez vos résultats de recherche pour votre cas d'utilisation souhaité",
      "search": "Rechercher",
      "searchBy": "Rechercher par",
      "resetFilters": "Réinitialiser les filtres",
      "advancedSearch": "Recherche avancée",
      "dct:type": "dt:type",
      "assetId": "ID d'actif"
    },
    "noResult": {
      "title": "Aucun résultat",
      "description": "Veuillez effectuer une recherche pour parcourir les offres de données disponibles dans le réseau"
    },
    "helpCard": {
      "title": "Comment ça marche ?",
      "description": "Découvrez le catalogue d'offres de données d'autres participants à l'espace de données. Vous pouvez rechercher, sélectionner et vous abonner aux offres de données disponibles dans l'espace de données.",
      "subtitle": "Vous voulez en savoir plus sur le fonctionnement de la négociation et de la consommation des offres de données ?",
      "documentation": "Documentation"
    },
    "offers": {
      "downloadSelected": "Télécharger la sélection",
      "transferSelected": "Transférer la sélection",
      "negotiate": "Négocier",
      "noOffer": "Aucune offre de données n'est disponible."
    },
    "offer-details": {
      "title": "Confirmer les négociations contractuelles",
      "description": "Description",
      "attachedPolicies": "Politiques attachées",
      "termsCheck": "J'accepte les termes du contrat et je souhaite démarrer la négociation du contrat et l'échange de données.",
      "negotiate": "Négocier",
      "negotiateAndDownload": "Négocier et télécharger",
      "negotiateAndTransfer": "Négocier et transférer",
      "transfer": "Transférer",
      "cancel": "Annuler",
      "attribute": "Attribut",
      "value": "Valeur",
      "endpointUrl": "URL du point de terminaison",
      "organization": "Organisation",
      "bpnNumber": "Numéro BPN",
      "manufacturerPartId": "ID de pièce du fabricant",
      "noOfAssets": "Nombre d'actifs sélectionnés",
      "membership": "Adhésion",
      "dismantlerBrands": "Marques autorisées pour le démantèlement",
      "frameworkAgreement": "Accord-cadre",
      "dismantler": "Démantèleur",
      "backToAssets": "Retour aux actifs",
      "noPolicyMatchTitle": "Actifs non négociés ou politiques non identiques",
      "noPolicyMatchText": "Vous essayez de télécharger des actifs qui n'ont pas encore été négociés. Ou certains des actifs que vous essayez de négocier n'ont pas des politiques identiques. Veuillez sélectionner les bons actifs et continuer.",
      "negotiateInProgress": "Négociation et téléchargement en cours",
      "negotiateAndDownloadSuccess": "Négociation et téléchargement terminés avec succès",
      "negotiateAndTransferSuccess": "Négociation et transfert terminés avec succès",
      "transferSuccess": "Transfert terminé avec succès",
      "progress": "Progression",
      "fetchShell": "Récupération du shell",
      "exportToCSV": "Exporter en CSV",
      "fetchJobFailed": "Erreur lors de la récupération des détails du job",
      "negotiateError": "Erreur lors du téléchargement des actifs",
      "dtr": "Registre de jumeaux numériques",
      "edc": "Actifs du connecteur",
      "browseDtr": "Parcourir le DTR"
    },
    "existingContracts": {
      "heading": "Contrats disponibles",
      "description": "Une description extraordinaire viendra ici !"
    },
    "dtr": {
      "title": "Shells de jumeaux numériques",
      "shells": "Parcourir les shells",
      "description": "Vous allez négocier automatiquement la récupération et l'exportation des Shells depuis le registre de jumeaux numériques du fournisseur sélectionné",
      "noPoliciesFound": "Aucune politique trouvée pour cet élément",
      "errorFetchingPolicies": "Erreur lors de la récupération des politiques. ",
      "negotiate": "Négocier"
    },
    "traceabilityTitle": "Découvrez les données de traçabilité"
  },
  "catalogSimulation": {
    "pageTitle": "Simuler des offres de données",
    "note": "Vérifiez lesquelles de vos offres de données existantes seraient visibles pour un participant spécifique de l'espace de données. Simulez un autre participant de l'espace de données et sélectionnez les justificatifs que vous supposez disponibles dans son portefeuille. La simulation vérifie si vos politiques d'accès et d'utilisation configurées accordent l'accès aux offres visées. Utilisez cette fonctionnalité pour valider vos offres de données et identifier les problèmes de configuration des politiques susceptibles d'empêcher d'autres participants d'y accéder.",
    "protocol": "Dataspace Protocol",
    "protocolSaturn": "DSP Saturn",
    "protocolJupiter": "DSP Jupiter",
    "bpnSearch": "Rechercher par numéro de partenaire commercial ou nom d'entreprise",
    "credentials": "Justificatifs",
    "credentialsNote": "Sélectionnez les justificatifs disponibles pour les participants simulés.",
    "simulate": "Simuler",
    "policy": "Politique",
    "credential": {
      "bpn": "Numéro de partenaire commercial",
      "membership": "Adhésion",
      "dataExchangeGovernance": "Gouvernance de l'échange de données",
      "sampleDismantler": "Démanteleur d'exemple"
    },
    "viewPolicy": "Voir la politique"
  },
  "assetUploadHistory": {
    "title": "Historique des téléchargements d'actifs",
    "subtitle": "Cet historique donne un aperçu des transactions sur les connecteurs d'espace de données de votre entreprise. Toutes les activités sur les actifs, les politiques et les définitions de contrat sont listées ici.",
    "refresh": "Actualiser",
    "processId": "ID du processus",
    "providerUrl": "URL du fournisseur",
    "createdOn": "Créé le",
    "totalItems": "Total des éléments",
    "successful": "Réussi",
    "failed": "Échoué",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "howItWork": {
      "title": "Comment ça marche ?",
      "description": "Vous pouvez trouver l'historique de tous vos actifs téléchargés dans différents espaces de données. Vous pouvez télécharger à nouveau les fichiers localement ou les transférer vers un emplacement externe. En cas d'erreurs, vous devez réessayer de télécharger ou renégocier l'offre de données.",
      "moreInfo": "Vous voulez en savoir plus sur l'historique des téléchargements et tout ce que vous pouvez faire ici ?"
    }
  },
  "assetDownloadHistory": {
    "subtitle": "L'historique vous donne un aperçu des données téléchargées par votre organisation disponibles à partir des contrats négociés dans l'espace de données. Si nécessaire, vous pouvez télécharger à nouveau les données à partir de cette liste d'historique.",
    "howItWorks": {
      "description": "Vous pouvez trouver l'historique de tous vos actifs téléchargés dans différents espaces de données. Vous pouvez télécharger à nouveau les fichiers localement ou les transférer vers un emplacement externe. En cas d'erreurs, vous devez réessayer de télécharger ou renégocier l'offre de données.",
      "moreInfo": "Vous voulez en savoir plus sur l'historique des téléchargements et tout ce que vous pouvez faire ici ?"
    },
    "downloadError": "Téléchargement échoué, veuillez réessayer !",
    "viewErrors": "Voir les erreurs",
    "processId": "ID du processus"
  },
  "digitalTwinBrowser": {
    "subHeading": "Voici vos jumeaux numériques et leurs sous-modèles. Vos jumeaux numériques sont exposés à l'espace de données via votre registre de jumeaux numériques.",
    "noDocumentError": "Aucun document d'aspect pour l'id actuel",
    "nameNotProvided": "Nom non fourni",
    "fetchDigitalTwinsError": "Échec de la récupération des jumeaux numériques",
    "fetchAspectDocumentError": "Échec de la récupération du document d'aspect",
    "fetchAspectModelError": "Échec de la récupération du modèle d'aspect",
    "detailsOverviewModalTitle": "Détails de l'aspect",
    "addItem": "Ajouter un élément",
    "detailsTable": {
      "idShort": "ID court",
      "displayName": "Nom d'affichage",
      "modelUrn": "URN du modèle"
    },
    "shellsTable": {
      "manufacturer": "ID de pièce du fabricant",
      "modifiedBy": "Utilisateur",
      "modifiedAt": "Heure"
    }
  },
  "connector": {
    "addNewConnector": "+ Ajouter un nouveau connecteur",
    "searchConnector": "Rechercher par nom du connecteur",
    "connectorModal": {
      "error": "Échec de la récupération des détails du connecteur"
    }
  },
  "column": {
    "name": "Nom",
    "connectorName": "Nom du connecteur",
    "contractId": "ID du contrat",
    "productId": "ID du produit",
    "manufacturerPartId": "ID de pièce du fabricant",
    "manufacturerId": "ID du fabricant",
    "digitalTwinType": "Type de jumeau numérique",
    "correlationId": "ID de corrélation",
    "requestId": "ID de demande",
    "bpn": "BPN",
    "createdAt": "Créé le",
    "createdBy": "Créé par",
    "attribute": "Attribut",
    "value": "Valeur",
    "url": "URL",
    "actions": "Actes",
    "lastUpdatedTime": "Dernière mise à jour",
    "status": "Statut",
    "requestedDate": "Date de demande",
    "policyType": "Type de politique",
    "modifiedBy": "Modifié par",
    "modifiedOn": "Modifié le",
    "syncStatus": "Statut de synchronisation",
    "assetId": "ID d'actif",
    "assetType": "Type d'actif",
    "type": "Taper",
    "createdFrom": "Créé à partir de",
    "createdTo": "Créé jusqu'à",
    "statusDuration": "Statut/Durée",
    "certifier": "Certificateur",
    "version": "Version",
    "registrationNumber": "N° d'enregistrement",
    "validUntil": "Valable jusqu'au",
    "offerId": "ID de l’offre",
    "errorMessage": "Message d'erreur",
    "globalAssetId": "ID d’actif global",
    "shellName": "Nom du shell",
    "contractAgreementId": "ID de l'accord contractuel",
    "signingDate": "Date de signature",
    "providerConnectorUrl": "URL du connecteur du fournisseur",
    "consumerConnectorUrl": "URL du connecteur du consommateur",
    "providerBpnl": "BPNL du fournisseur",
    "consumerBpnl": "BPNL du consommateur",
    "counterPartyId": "ID de la contrepartie",
    "resourceId": "ID de la ressource",
    "resourceType": "Type de ressource",
    "transactionMethod": "Méthode de transaction",
    "trustLevel": "Niveau de confiance",
    "partId": "ID de pièce",
    "sentBy": "Envoyé par",
    "partner": "Partenaire",
    "sentOn": "Envoyé le",
    "intrinsicId": "ID intrinsèque",
    "id": "ID",
    "catenaXId": "ID Catena-X",
    "customerPartId": "ID de pièce client"
  },
  "messagesBrowser": {
    "fetchMessagesError": "Échec de la récupération des messages",
    "openRelatedMessage": "Ouvrir le message associé",
    "messagesTable": {
      "context": "Contexte",
      "senderBpn": "BPN de l'expéditeur",
      "receiverBpn": "BPN du destinataire",
      "correlationId": "ID de corrélation",
      "jobId": "ID du job",
      "conversationId": "ID de conversation"
    },
    "messageType": {
      "ecu": "ÉCU",
      "generic": "Générique",
      "quality": "Qualité",
      "ccmpush": "Poussée CCM",
      "ccmrequest": "Requête CCM",
      "ccmstatus": "Statut CCM",
      "ccmavailable": "CCM Disponible",
      "blockNotification": "Notification de blocage",
      "dtrEvent": "Événement DTR",
      "csm": "CSM"
    }
  },
  "bpnSelector": {
    "selectFromList": "Sélectionner dans la liste",
    "enterManually": "Entrez manuellement",
    "selectPlaceholder": "Sélectionnez un emplacement BPN",
    "manualPlaceholder": "Saisissez BPN (par exemple, BPNL123456789ABC)",
    "validFormat": "Format BPN valide",
    "invalidFormat": "Format BPN invalide",
    "invalidFormatHint": "Format : BPNL + 12 caractères alphanumériques",
    "formatHint": "Format : BPNL123456789ABC (16 caractères au total)",
    "selected": "Choisi"
  },
  "searchableSelect": {
    "pressEnterToUse": "Appuyez sur Entrée pour utiliser ce BPNA/BPNS",
    "placeholderText": "Veuillez saisir un BPNA/BPNS valide",
    "placeholder": "Sélectionnez ou saisissez un BPNA/BPNS",
    "validBpnWarning": "Attention ! La valeur BPNA/BPNS saisie n'est validée auprès d'aucune source, contrairement à BP Explore. Si vous souhaitez tout de même l'utiliser, appuyez sur Entrée.",
    "enterValidBpn": "Saisissez un BPNA/BPNS valide (format attendu ^(BPNA|BPNS).{12}$)"
  },
  "blockNotifications": {
    "title": "Bloquer les notifications",
    "description": "Bienvenue dans la solution d'échange de gestion de certificats de partenaires commerciaux de bout en bout, facile à utiliser, dans Catena-X.",
    "recentNotifications": "Notifications récentes",
    "totalAffected": "Total des pièces concernées",
    "top5": "Top 5 des partenaires d'échange",
    "sendNotifications": "Envoyer des notifications de blocage",
    "sendUpdate": "Envoyer la mise à jour",
    "sentHistory": "Historique des notifications envoyées",
    "receivedHistory": "Historique des notifications reçues",
    "sendDescription": "Créez et partagez vos certificats de site dans le réseau Catena-X",
    "learnMore": "En savoir plus sur le blocage des notifications",
    "filters": {
      "lastYear": "1 an dernier",
      "sixMonths": "6 mois",
      "threeMonths": "3 mois",
      "oneMonth": "1 mois",
      "lastWeek": "La semaine dernière",
      "selectDateRange": "Sélectionnez une plage de dates",
      "bpnOrCompany": "Numéro de partenaire commercial ou nom de l'entreprise"
    },
    "stats": {
      "totalAffectedParts": "Total des pièces concernées",
      "topExchangePartners": "Principaux {count} partenaires Exchange",
      "sentNotifications": "Notifications envoyées",
      "receivedNotifications": "Notifications reçues"
    },
    "sentHistoryDescription": "Utilisez la zone pour gérer vos demandes de données de certificat auprès des partenaires.",
    "receivedHistoryDescription": "Affichez et gérez les notifications de blocage reçues des partenaires.",
    "table": {
      "conversationName": "Nom de la conversation",
      "problemId": "ID du problème",
      "partner": "Partenaire",
      "bpn": "Numéro BPN",
      "createdAt": "Créé à",
      "partnerName": "Nom du partenaire",
      "sentBy": "Envoyé par",
      "sentOn": "Envoyé le",
      "receivedOn": "Reçu le"
    },
    "errors": {
      "fetchSentNotifications": "Échec de la récupération des notifications envoyées",
      "fetchStatistics": "Échec du chargement des statistiques de notification",
      "fetchRecentNotifications": "Échec du chargement des notifications récentes",
      "invalidDateRange": "Impossible de récupérer des statistiques sans plage de dates valide",
      "sendNotificationFailed": "Échec de l'envoi de la notification de blocage. ",
      "validationFailed": "Veuillez remplir tous les champs obligatoires"
    },
    "confirmationText": "Je comprends et confirme avoir correctement renseigné toutes les informations requises. ",
    "validityDisclaimer": "T-Systems ne vérifie pas la validité des informations de métadonnées renseignées ici. ",
    "generalInformation": "Informations générales",
    "jobName": "Nom du travail",
    "jobNamePlaceholder": "Entrez le nom du travail",
    "receiverBpn": "BPN du récepteur",
    "expectedResponseBy": "Réponse attendue par",
    "success": {
      "notificationSent": "Notification de blocage envoyée avec succès",
      "notificationUpdateSent": "Mise à jour de notification de blocage envoyée avec succès"
    },
    "groups": {
      "notificationInformation": "Informations sur les notifications",
      "blockInformationItems": "Bloquer les éléments d'information *",
      "partIdentification": "Identification des pièces",
      "componentLevelContainment": "Confinement au niveau des composants",
      "periodAndVolumeLevelContainment": "Période et niveau de confinement",
      "deliveryInformation": "Informations de livraison",
      "quantities": "Quantités",
      "sizeOfProductionLot": "Taille du lot de production",
      "numberOfPartsPerDeliveryNote": "Nombre de pièces par bon de livraison",
      "numberOfPartsPerPackage": "Nombre de pièces par colis",
      "locationInContainer": "Emplacement dans le conteneur (facultatif)"
    },
    "fields": {
      "problemId": "ID du problème",
      "notificationStatus": "Statut des notifications",
      "problemDescription": "Description du problème",
      "updateReason": "Raison de la mise à jour",
      "catenaXId": "Identifiant Catena-X",
      "blockStatus": "État du blocage",
      "manufacturingLocationId": "ID du lieu de fabrication",
      "customerPartId": "ID de pièce client",
      "integrationLevel": "Niveau d'intégration",
      "localIdentifiers": "Identifiants locaux",
      "key": "Clé",
      "value": "Valeur",
      "orderNumber": "Numéro de commande",
      "deliveryNoteNumber": "Numéro du bon de livraison",
      "packageNumber": "Numéro de colis",
      "deliveryPlace": "Lieu de livraison",
      "productionDate": "Date de production",
      "deliveryDate": "La date de livraison",
      "quantity": "Quantité",
      "unit": "Unité",
      "xPosition": "Position X",
      "yPosition": "Position Y",
      "smallLoadCarrierLayer": "Couche de support de petites charges"
    },
    "editNotification": "Modifier la notification",
    "importJson": {
      "title": "Importer un fichier JSON",
      "description": "Téléchargez un fichier JSON pour remplir automatiquement le formulaire avec les données fournies. ",
      "importButton": "Importer depuis JSON",
      "dropFileHere": "Glissez et déposez votre fichier JSON ici",
      "selectFile": "Sélectionnez un fichier",
      "import": "Importer",
      "success": "Données de formulaire importées avec succès depuis JSON",
      "parseError": "Échec de l'analyse du fichier JSON",
      "readError": "Échec de la lecture du fichier. "
    },
    "partPicker": {
      "button": "Sélecteur de pièces",
      "title": "Sélecteur de pièces",
      "description": "Sélectionnez des jumeaux numériques à partir de vos données fournisseur pour remplir automatiquement les éléments d'information de blocage.",
      "addToForm": "Ajouter au formulaire",
      "success": "{count} élément(s) d'information de blocage ajouté(s) au formulaire.",
      "error": "Échec du chargement des détails de l'aspect. Veuillez réessayer."
    },
    "tooltips": {
      "problemDescription": "Un champ de texte libre qui indique pourquoi les pièces doivent être bloquées.",
      "catenaXId": "L’ID Catena-X entièrement anonyme de la pièce ou du lot sérialisé.",
      "blockStatus": "Statut de l'article individuel dans une notification de blocage.",
      "manufacturingLocationId": "Adresse du site du fournisseur à partir duquel les composants sont livrés.",
      "updateReason": "Texte libre décrivant pourquoi la liste des pièces endommagées fournie précédemment doit être mise à jour."
    },
    "updateNotification": "Notification de mise à jour",
    "notificationDetails": "Détails des notifications",
    "howTo": {
      "doc": "Vous voulez en savoir plus sur le fonctionnement des notifications de blocage ?",
      "description": "Découvrez le catalogue d'offres de données des autres entreprises membres de Catena-X. "
    }
  },
  "ecu": {
    "title": "Unité de Contrôle Électronique (ECU)",
    "description": "Bienvenue dans la vue d'ensemble facile à utiliser pour votre échange de données ECU au sein du réseau Catena-X.",
    "sentHistory": "Historique des messages envoyés",
    "receivedHistory": "Historique des messages reçus",
    "sentHistoryDescription": "Afficher et gérer les messages ECU sortants envoyés aux partenaires.",
    "receivedHistoryDescription": "Afficher et gérer les messages ECU entrants reçus des partenaires.",
    "tiles": {
      "item_1": {
        "title": "Messages sortants",
        "description": "Consulter les messages ECU sortants vers les partenaires du réseau Catena-X"
      },
      "item_2": {
        "title": "Messages entrants",
        "description": "Recevoir les messages entrants des partenaires ECU du réseau Catena-X"
      },
      "item_3": {
        "title": "Guide utilisateur ECU",
        "description": "En savoir plus sur le cas d’usage ECU et son fonctionnement"
      },
      "item_4": {
        "title": "Documentation développeur",
        "description": "Accès rapide aux API pour configurer et gérer l’échange de données ECU"
      },
      "item_5": {
        "title": "Actifs ECU",
        "description": "Consulter et rechercher tous les actifs ECU"
      },
      "item_6": {
        "title": "Journaux de processus ECU",
        "description": "Accéder aux journaux de processus pour la transparence et la gestion des incidents"
      }
    },
    "howTo": {
      "description": "Créez des chaînes d'approvisionnement résilientes grâce à des notifications d'état automatisées et à des boucles de rétroaction pour les unités de contrôle électronique au sein du réseau Catena-X.",
      "doc": "Vous souhaitez en savoir plus sur le fonctionnement de la messagerie des unités de contrôle électronique (ECU) ?"
    },
    "filters": {
      "senderBpn": "BPN de l'expéditeur",
      "receiverBpn": "BPN du destinataire",
      "catenaXId": "ID Catena-X",
      "ecuId": "ID ECU",
      "catenaXSiteId": "ID du site Catena-X"
    },
    "table": {
      "conversationName": "Nom de la conversation",
      "senderBpn": "BPN de l'expéditeur",
      "receiverBpn": "BPN du destinataire",
      "sentOn": "Envoyé le",
      "receivedOn": "Reçu le"
    },
    "errors": {
      "fetchNotifications": "Échec de la récupération des notifications ECU"
    },
    "stats": {
      "total": "Total",
      "messagesPerCountry": "Messages par pays",
      "sentMessages": "Messages envoyés",
      "receivedMessages": "Messages reçus",
      "technicalSpecifications": "Spécifications techniques",
      "connector": "Connecteur",
      "connectors": "Connecteurs",
      "policies": "Politiques",
      "viewAllConnectors": "Voir tous les connecteurs",
      "viewAllPolicies": "Voir toutes les politiques"
    }
  },
  "qualityAlert": {
    "sendSuccess": "Envoyé avec succès !",
    "sendAlert": "Envoyer une alerte de qualité",
    "sendInvestigation": "Envoyer une enquête de qualité",
    "updateSuccess": "Mis à jour avec succès!",
    "updateAlert": "Mettre à jour l'alerte de qualité",
    "updateInvestigation": "Mettre à jour une enquête de qualité",
    "acceptConfirmTitle": "Accepter une alerte de qualité",
    "acceptConfirmDesc": "En cliquant sur oui, vous acceptez cette alerte de qualité et acceptez de prendre les mesures appropriées.",
    "rejectConfirmTitle": "Rejeter l'alerte qualité",
    "rejectConfirmDesc": "En cliquant sur oui, vous rejetez cette alerte de qualité. "
  },
  "traceability": {
    "title": "Traçabilité",
    "description": "Bienvenue dans l'application de traçabilité de bout en bout facile à utiliser pour l'échange de données Catena-X",
    "createQualityAlertOrInvestigation": "Créer une alerte qualité ou une investigation",
    "learnMore": "En savoir plus sur la traçabilité",
    "recentIndustryCoreNotifications": "Notifications récentes concernant les principales industries",
    "recentTraceabilityNotifications": "Notifications de traçabilité récentes",
    "tabs": {
      "inbound": "Entrant",
      "outbound": "Sortant",
      "published": "Publié",
      "consumed": "Consommé"
    },
    "howTo": {
      "description": "Découvrez le catalogue d'offres de données des autres entreprises membres de Catena-X. ",
      "doc": "Envie d’en savoir plus sur le travail de négociation d’offres data et de consommation ?"
    },
    "tiles": {
      "createOffer": {
        "title": "Créer une offre de traçabilité",
        "description": "Créer et partager des données de traçabilité avec les participants du réseau Catena-X"
      },
      "discoverData": {
        "title": "Découvrez les données de traçabilité",
        "description": "Rechercher et négocier des données de traçabilité au sein du réseau Catena-X"
      },
      "notifications": {
        "title": "Notifications de traçabilité",
        "description": "Accès rapide aux notifications de qualité telles que les alertes qualité et les enquêtes qualité"
      },
      "industryCoreNotifications": {
        "title": "Notifications principales du secteur",
        "description": "Afficher les notifications d'événements de jumeaux numériques telles que la mise à jour du sous-modèle, les événements de commentaires, etc."
      },
      "contractAgreements": {
        "title": "Accords contractuels",
        "description": "Afficher tous les accords contractuels fournis et consommés"
      },
      "exchangeHistory": {
        "title": "Historique des échanges",
        "description": "Gagnez en transparence sur votre historique d’échanges de données de traçabilité dans le réseau Catena_X et vos partenaires",
        "uploadHistory": "Historique de téléchargement",
        "downloadHistory": "Historique de téléchargement"
      },
      "blockNotifications": {
        "title": "Bloquer les notifications",
        "description": "Signalez facilement et rapidement les défauts et envoyez des notifications de blocage aux partenaires pour les pièces concernées."
      }
    }
  },
  "useCases": {
    "ecu": {
      "title": "ECU",
      "description": "Messagerie ECU"
    },
    "ecuTest": {
      "title": "ECU-TEST",
      "description": "Messagerie ECU sans restriction aux partenaires commerciaux"
    },
    "co2": {
      "title": "Durabilité et empreinte CO2",
      "description": "Durabilité et empreinte CO2"
    },
    "dcm": {
      "title": "Gestion des données des partenaires commerciaux",
      "description": "Gestion de la demande et de la capacité - moins de goulets d'étranglement, plus de sécurité"
    },
    "ce": {
      "title": "Économie circulaire",
      "description": "Économie circulaire - utilisation maximale des ressources"
    },
    "companyCertificates": {
      "title": "Certificats d'entreprise",
      "description": "Simplifie le processus de gestion et d'échange des certificats d'entreprise, réduisant la charge liée au maintien de plusieurs certificats pour différents clients"
    },
    "cyberSecurityKpi": {
      "title": "Indicateurs de cybersécurité",
      "description": "Simplifie la gestion et l'échange des KPI de cybersécurité, réduisant la charge de maintenir plusieurs KPI pour différents clients"
    },
    "traceability": {
      "title": "Traçabilité",
      "description": "La traçabilité consiste à suivre les pièces et matériaux physiques tout au long de la chaîne de valeur afin de permettre des cas d'utilisation basés sur les données à tous les niveaux n-tier sans compromettre la souveraineté des données"
    },
    "blockingNotifications": {
      "title": "Notifications bloquantes",
      "description": ""
    },
    "batteryPassBmw": {
      "title": "Passeport batterie (BMW)",
      "description": "Passeport batterie BMW - utilisation maximale des ressources dans la chaîne d’approvisionnement des batteries"
    },
    "modularProduction": {
      "title": "Production modulaire",
      "description": "Production modulaire"
    },
    "qualityManagement": {
      "title": "Gestion de la qualité",
      "description": "Gestion de la qualité"
    },
    "realTimeControl": {
      "title": "Contrôle en temps réel",
      "description": "Contrôle en temps réel"
    }
  },
  "certificateUpload": {
    "title": "Certificat",
    "pageTitle": "Ajouter un nouveau certificat",
    "cardTitle": "Téléversez votre document de certificat pour commencer",
    "dragAndDrop": "Glissez-déposez votre fichier de certificat ici.",
    "supportedFiles": "Types de fichiers pris en charge : .pdf",
    "invalidFileType": "Seuls les fichiers PDF sont pris en charge.",
    "fileTooLarge": "Le fichier sélectionné dépasse la taille maximale autorisée.",
    "supportedTypesLabel": "Les types de certificats suivants sont pris en charge",
    "supportedTypesTooltip": "Veuillez consulter la documentation pour plus d'informations.",
    "continue": "Continuer",
    "remove": "Supprimer",
    "preview": {
      "title": "Aperçu du certificat",
      "subtitle": "Document original téléversé",
      "emptyMessage": "L'aperçu de votre certificat s'affichera ici une fois téléversé.",
      "emptyTitle": "Téléversez un certificat pour l'afficher ici",
      "emptySubtitle": "Téléversez un PDF pour l'afficher ici.",
      "fallback": "L'aperçu n'est pas disponible dans ce navigateur.",
      "openCertificate": "Ouvrir le certificat",
      "ariaLabel": "Aperçu du certificat téléversé",
      "prevPage": "Page précédente",
      "nextPage": "Page suivante"
    },
    "processingMethod": {
      "title": "Confirmer la méthode de traitement",
      "subtitle": "Choisissez comment vous souhaitez saisir les informations du certificat",
      "fileSummary": "Nom exemple.pdf",
      "proceedWithAi": "Continuer avec l'IA",
      "recommended": "Recommandé",
      "continueManually": "Continuer manuellement",
      "proceedWithAiDescLine1": "Notre IA extraira automatiquement les informations du certificat de votre document téléversé et préremplira les champs du formulaire.",
      "continueManuallyDescLine1": "Vous pouvez saisir manuellement les informations du certificat via le formulaire.",
      "descLine2": "Vous pouvez vérifier et modifier les données avant l'enregistrement."
    },
    "aiProcessing": {
      "title": "Traitement du certificat",
      "subtitle": "Notre IA extrait les informations de votre document",
      "analyzingTitle": "Analyse de votre certificat...",
      "completedTitle": "Analyse du certificat terminée",
      "analyzingSubtitle": "Cela peut prendre quelques secondes",
      "errorSubtitle": "Veuillez relancer l'analyse",
      "didYouKnow": "Le saviez-vous ?",
      "expirationNotice": "Nous vous avertirons automatiquement si votre certificat approche de son expiration",
      "shareNotice": "Vous pouvez partager le certificat que vous téléversez actuellement avec plusieurs partenaires en même temps",
      "errorMessage": "Nous n'avons pas pu analyser votre certificat. Veuillez réessayer.",
      "retry": "Réessayer",
      "errors": {
        "extractionFailed": "Nous n'avons pas pu analyser votre certificat. Veuillez réessayer.",
        "noFile": "Aucun fichier valide n'a été fourni. Veuillez téléverser un fichier de certificat pris en charge et réessayer.",
        "unsupportedFileType": "Type de fichier non pris en charge. Veuillez téléverser un fichier de certificat PDF, JPEG ou PNG.",
        "invalidImage": "L'image téléversée n'a pas pu être traitée. Veuillez téléverser une image nette et prise en charge.",
        "imageDimensionsExceeded": "L'image téléversée est trop grande. Veuillez utiliser une image avec des dimensions plus petites.",
        "fileSizeExceeded": "Le fichier téléversé est trop volumineux. Veuillez sélectionner un fichier de certificat plus petit.",
        "notCompanyCertificate": "Le document téléversé n'est pas reconnu comme un certificat d'entreprise. Veuillez téléverser un certificat d'entreprise valide.",
        "invalidCertificateType": "Le type de certificat de ce document n'est pas pris en charge.",
        "certificateTextTooLong": "Le contenu du certificat est trop long pour être traité. Veuillez téléverser un document plus court ou plus propre.",
        "processingTimeout": "Le traitement du document a dépassé le délai. Veuillez réessayer.",
        "processingInterrupted": "Le traitement du document a été interrompu. Veuillez réessayer.",
        "noDataExtracted": "Aucune donnée de certificat n'a pu être extraite de ce document.",
        "batchExtractionFailed": "L'extraction du certificat a échoué lors du traitement des pages du document. Veuillez réessayer.",
        "aiResponseTruncated": "La réponse du service d'extraction a été tronquée. Veuillez réessayer plus tard.",
        "processingFailed": "Le certificat n'a pas pu être traité. Veuillez réessayer.",
        "pdfUnsupported": "Ce PDF contient un contenu ou une structure non pris en charge. Veuillez téléverser un autre PDF.",
        "llmUnavailable": "Le service d'extraction IA est actuellement surchargé. Veuillez réessayer dans un instant.",
        "auth": "Vous n'êtes pas autorisé à effectuer l'extraction de certificat. Veuillez vous reconnecter.",
        "unavailable": "L'extraction de certificat est actuellement indisponible.",
        "rateLimit": "Trop de demandes d'extraction. Veuillez réessayer plus tard.",
        "fileReadFailed": "Le fichier téléversé n'a pas pu être lu. Veuillez téléverser de nouveau le fichier et réessayer.",
        "serverError": "Une erreur serveur est survenue pendant l'extraction du certificat. Veuillez réessayer plus tard.",
        "connectionTimeout": "La requête a pris trop de temps et la connexion a été fermée. Veuillez réessayer — les documents volumineux peuvent nécessiter quelques minutes de traitement."
      },
      "processingProgress": "Traitement... {percent}% terminé",
      "steps": {
        "validating": "Validation du document",
        "preparing": "Préparation du document",
        "extractingText": "Extraction du contenu textuel",
        "convertingImages": "Conversion des pages en images",
        "waitingLlm": "Attente de la réponse de l'IA",
        "analyzing": "Analyse du certificat",
        "batchProgress": "Lot de pages {done} sur {total}",
        "merging": "Finalisation des résultats"
      }
    },
    "review": {
      "title": "Détails du certificat",
      "subtitle": "Vérifiez toutes les données préremplies ci-dessous",
      "successMessage": "Les données du certificat ont été extraites avec succès. Veuillez vérifier et modifier si nécessaire.",
      "certificateName": "Nom du certificat",
      "issuer": "Émetteur",
      "certificateId": "ID du certificat",
      "ownerOrganization": "Organisation propriétaire",
      "validFrom": "Valide à partir du",
      "validUntil": "Valide jusqu'au",
      "scope": "Périmètre",
      "confirmation": "Je confirme que les données saisies sont correctes (texte de remplacement)",
      "back": "Retour",
      "save": "Enregistrer le certificat",
      "previewTitle": "Aperçu du certificat",
      "previewSubtitle": "Document original téléversé",
      "enclosedSitesSubtitle": "Sélectionnez les emplacements BPNA/BPNS couverts par ce certificat.",
      "aiConfirmation": "J'accepte et reconnais que l'IA n'est pas responsable des données renseignées.",
      "aiNotice": "Le contenu ci-dessous a été renseigné à l'aide de l'IA. L'IA peut commettre des erreurs. Veuillez vous assurer que les données sont correctes.",
      "metadataConfirmation": "Je comprends et confirme que j'ai correctement rempli toutes les informations requises et T-Systems n'est pas responsable en cas d'informations incorrectes et de rejet d'offre.",
      "metadataNotice": "T-Systems ne vérifie pas la validité des informations de métadonnées saisies ici. Veuillez vous assurer d'avoir renseigné des informations correctes et complètes."
    }
  },
  "backendUnavailable": {
    "title": "Service temporairement indisponible",
    "subtitle": "Le service backend est actuellement inaccessible. Veuillez vérifier votre connexion ou réessayer plus tard.",
    "retryButton": "Réessayer",
    "checking": "Vérification de la connexion..."
  }
}
